<!-- Click outside to close context menu -->
<div class="context-menu-overlay" *ngIf="layerContextMenu.visible" (click)="hideLayerContextMenu()"></div>

<!-- Project Details Header -->
<div *ngIf="showProjectDetails" class="project-details-header">
  <div class="project-details-container">
    <div class="project-info">
      <div class="project-title">
        <h2>{{ projectData?.project_name || 'Loading...' }}</h2>
        <button class="close-btn" (click)="closeProjectDetails()" title="Close Project Details">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div *ngIf="isLoadingProject" class="loading-indicator">
        <div class="spinner"></div>
        <span>Loading project details...</span>
      </div>
      
      <div *ngIf="!isLoadingProject && projectData" class="project-details-grid">
        <div *ngIf="false" class="detail-item">
          <span class="label">Project Code:</span>
          <span class="value">{{ projectData.project_code || 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Status:</span>
          <span class="value" [ngClass]="'status-' + (projectData.stage || 'unknown')">{{ projectData.stage || 'N/A' }}
          </span>
        </div>
        <div class="detail-item">
          <span class="label">Start Date:</span>
          <span class="value">{{ projectData.start_date ? (projectData.start_date | date:'mediumDate') : 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">End Date:</span>
          <span class="value">{{ projectData.end_date ? (projectData.end_date | date:'mediumDate') : 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Budget:</span>
          <span class="value">{{ projectData.budget_amount
 ? (projectData.budget_amount | currency:'INR':'symbol':'1.0-0') : 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Assigned To:</span>
          <span class="value">{{ projectData.assigned_staff_name || 'Not Assigned' | titlecase}}</span>
        </div>
        <div *ngIf="projectData?.client_first_name && projectData?.client_last_name" class="detail-item">
          <span class="label">Owner:</span>
          <span class="value">{{ projectData.client_first_name + ' ' + projectData.client_last_name || 'N/A' }}</span>
        </div>
        <div *ngIf="projectData?.description" class="detail-item full-width">
          <span class="label">Description:</span>
          <span class="value">{{ projectData.description || 'No description available' }}</span>
        </div>
      </div>
      
      <!-- Location Data Section -->
      <div *ngIf="!isLoadingProject && projectData && projectData.location" class="location-section">
        <h3 class="location-title">
          <svg class="location-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          Project Location
        </h3>
        <div class="location-grid">
          <div class="location-item">
            <span class="location-label">Coordinates:</span>
            <span class="location-value clickable-coordinates" (click)="centerMapOnProjectLocation(projectData.location)" title="Click to center map on this location">
              {{ projectData.location.lat }}, {{ projectData.location.long }}
            </span>
          </div>
          <div class="location-item">
            <span class="location-label">City:</span>
            <span class="location-value">{{ projectData.location.city || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">State:</span>
            <span class="location-value">{{ projectData.location.state || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Country:</span>
            <span class="location-value">{{ projectData.location.country || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Pincode:</span>
            <span class="location-value">{{ projectData.location.pincode || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Khasra No:</span>
            <span class="location-value">{{ projectData.location.khasra_no || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Area:</span>
            <span class="location-value">{{ projectData.location.area || 'N/A' }}</span>
          </div>
          <div class="location-item full-width">
            <span class="location-label">Address Line 1:</span>
            <span class="location-value">{{ projectData.location.address_line_1 || 'N/A' }}</span>
          </div>
          <div class="location-item full-width" *ngIf="projectData.location.address_line_2">
            <span class="location-label">Address Line 2:</span>
            <span class="location-value">{{ projectData.location.address_line_2 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="false" class="header">
  <h1> Enhanced GIS Editor</h1>
  <div class="project-selector">
    <label>Project:</label>
    <select id="projectSelect">
      <option value="NH44_Delhi_Mumbai">NH-44 Delhi-Mumbai</option>
      <option value="SH15_Pune_Nashik">SH-15 Pune-Nashik</option>
      <option value="MDR23_Rural_Connect">MDR-23 Rural Connect</option>
    </select>
    <button class="btn" id="settingsBtn">⚙️ Settings</button>
  </div>
</div>

<div class="container" [class.container--sidebar-collapsed]="sidebarCollapsed || compactForBoq" [class.container--boq-compact]="compactForBoq">
  <div class="sidebar" [class.sidebar--collapsed]="sidebarCollapsed">
    <div class="sidebar__main">
    <nav class="sidebar-nav" aria-label="GIS tools">
      <ng-container *ngFor="let tab of sidebarPrimaryTabs">
      <button
        type="button"
        class="layer-tab"
        *ngIf="!tab.lrsOnly || enableLrsTab"
        [attr.data-tab]="tab.id"
        [class.active]="activeSidebarTab === tab.id"
        [title]="tab.title"
        (click)="onSidebarNavTab(tab.id)"
      >
        {{ tab.label }}
      </button>
      </ng-container>
      <div class="sidebar-nav-more">
        <button
          type="button"
          class="layer-tab sidebar-nav-more-btn"
          [class.active]="isSidebarMoreTabActive()"
          [attr.aria-expanded]="sidebarNavMoreOpen"
          title="More tools"
          (click)="toggleSidebarNavMore($event)"
        >
          More
        </button>
        <div class="sidebar-nav-menu" *ngIf="sidebarNavMoreOpen" role="menu">
          <button
            type="button"
            class="sidebar-nav-menu-item"
            *ngFor="let tab of sidebarMoreTabs"
            [class.active]="activeSidebarTab === tab.id"
            [title]="tab.title"
            role="menuitem"
            (click)="onSidebarNavTab(tab.id)"
          >
            {{ tab.label }}
          </button>
        </div>
      </div>
      <button
        type="button"
        class="sidebar__collapse-btn"
        (click)="toggleSidebar()"
        aria-label="Hide panel"
        title="Hide panel"
      >
        <span class="sidebar__collapse-icon">‹</span>
      </button>
    </nav>

    <!-- Layers Tab (Layer Management) -->
    <div class="tab-content" id="layers-tab">
      <div class="sidebar-section qgis-layer-panel layer-management-tab-content">
        <div class="layer-chrome">
        <div class="layer-toolbar" role="toolbar" aria-label="Layer actions">
          <button type="button" class="layer-tool-btn" (click)="showCreateLayerDialog()" title="Add a new drawing layer" aria-label="Add a new drawing layer">
            <span class="layer-tool-btn__icon">＋</span>
          </button>
          <button type="button" class="layer-tool-btn" (click)="showImportLayerDialogWrapper()" title="Import a layer from file" aria-label="Import a layer from file">
            <span class="layer-tool-btn__icon">📥</span>
          </button>
          <button type="button" class="layer-tool-btn" (click)="exportAllLayers()" title="Export all layers" aria-label="Export all layers">
            <span class="layer-tool-btn__icon">💾</span>
          </button>
          <button type="button" class="layer-tool-btn" (click)="showCreateGroupDialog()" title="Create a layer category" aria-label="Create a layer category">
            <span class="layer-tool-btn__icon">🗂️</span>
          </button>
        </div>
        <div class="layer-search-wrap">
          <span class="layer-search-wrap__icon" title="Search layers" aria-hidden="true">🔍</span>
          <input
            type="search"
            [value]="layerSearchTerm"
            (input)="layerSearchTerm = $any($event.target).value; updateLayerManagementUI()"
            class="layer-search-input"
            placeholder="Filter layers…"
            title="Filter layers by name"
            aria-label="Filter layers">
          <button
            type="button"
            class="layer-search-clear"
            *ngIf="layerSearchTerm"
            (click)="clearLayerSearch()"
            title="Clear filter"
            aria-label="Clear filter">×</button>
        </div>
        </div>
        <div class="drawing-target-hint" title="Active sketch target — select another layer to change">
          <span class="drawing-target-hint__label">Draw on</span>
          <strong class="drawing-target-hint__value">{{ getDrawingTargetLabel() }}</strong>
        </div>
        <app-lrs-layer-tree
          [includeBasemaps]="true"
          [visibility]="nhaiLayerVisibility"
          [counts]="nhaiLayerCounts"
          [selectedBaseMap]="selectedBaseMapKey"
          [expanded]="nhaiExpandedGroups"
          (visibilityChange)="onNhaiVisibility($event)"
          (baseMapChange)="pickBaseMap($event)"
          (expandedChange)="nhaiExpandedGroups = $event"
        ></app-lrs-layer-tree>

        <div class="sidebar-section desk-stack-section">
          <h3>Desk stack</h3>
          <p class="desk-stack-hint">Toggle layers 1–6 on the map (desk.md). Create/edit stays in Road + LRS tabs.</p>
          <label class="desk-stack-row" *ngFor="let layer of deskStackLayers">
            <input
              type="checkbox"
              [checked]="deskStack[layer.key]"
              (change)="onDeskStackToggle(layer.key, $any($event.target).checked)"
            />
            <span class="desk-stack-label">{{ layer.label }}</span>
          </label>
          <label class="desk-stack-row desk-stack-filter" *ngIf="deskStack.l5_events && deskEventTypeOptions.length">
            <span class="desk-stack-label">L5 type filter</span>
            <select
              multiple
              [(ngModel)]="deskEventTypeFilter"
              (ngModelChange)="onDeskEventTypeFilterChange()"
              class="desk-stack-multiselect"
            >
              <option *ngFor="let t of deskEventTypeOptions" [value]="t.id">{{ t.label }}</option>
            </select>
          </label>
          <p class="desk-stack-status" *ngIf="deskStackStatus">{{ deskStackStatus }}</p>
        </div>

        <div class="layer-groups-container">
          <div 
            *ngFor="let groupEntry of getLayerGroups(); trackBy: trackByGroupName"
            class="layer-group-item"
            [class.expanded]="isGroupExpanded(groupEntry.name)">
            <div class="group-header"
              (click)="toggleGroupExpanded(groupEntry.name)"
              [title]="isGroupExpanded(groupEntry.name) ? 'Collapse ' + groupEntry.name : 'Expand ' + groupEntry.name">
              <span class="group-toggle-icon">{{ isGroupExpanded(groupEntry.name) ? '▼' : '▶' }}</span>
              <span class="group-name">{{ groupEntry.name }}</span>
              <span class="group-count" [title]="groupEntry.layers.length === 1 ? '1 layer in this category' : (groupEntry.layers.length + ' layers in this category')">({{ groupEntry.layers.length }})</span>
              <div class="group-actions" (click)="$event.stopPropagation()" *ngIf="!isFixedLayerGroup(groupEntry.name)">
                <button class="icon-btn-small" (click)="ungroupLayers(groupEntry.name)" title="Ungroup category">📂</button>
              </div>
            </div>
            <div class="group-layers" *ngIf="isGroupExpanded(groupEntry.name)">
              <div 
                *ngFor="let layerId of groupEntry.layers; trackBy: trackByLayerId"
                class="layer-item"
                [class.selected]="selectedLayerId === layerId"
                [class.layer-item--overlay]="isOverlayLayer(layerId)"
                [class.locked]="isLayerLocked(layerId)"
                (contextmenu)="showLayerContextMenu($event, layerId)">
                <div class="layer-row" (click)="selectLayer(layerId)">
                  <div class="layer-controls-left">
                    <label class="layer-visibility-toggle"
                      [matTooltip]="getLayerVisibilityTooltip(layerId)"
                      matTooltipPosition="above"
                      matTooltipTouchGestures="off"
                      (click)="$event.stopPropagation()">
                      <input 
                        type="checkbox" 
                        [checked]="getLayerInfo(layerId).visible"
                        [disabled]="layerId === 'osm_vertex_nodes' && !osmNetworkEnabled"
                        (change)="toggleLayerEnhanced(layerId, $any($event.target).checked)"
                        (click)="$event.stopPropagation()">
                      <span class="checkmark"></span>
                    </label>
                    <span class="layer-icon"
                      [matTooltip]="getLayerFullLabel(layerId)"
                      matTooltipPosition="above"
                      matTooltipTouchGestures="off">{{ getLayerIcon(layerId) }}</span>
                    <div class="layer-label-block">
                      <span class="layer-name"
                        [matTooltip]="getLayerNameTooltip(layerId)"
                        matTooltipPosition="above"
                        matTooltipTouchGestures="off">{{ getLayerDisplayName(layerId) }}</span>
                      <span class="layer-meta" *ngIf="layerId === 'osm_vertex_nodes'"
                        [matTooltip]="'Vertex nodes appear at zoom ' + osmNodesMinZoom + ' or higher'"
                        matTooltipPosition="above"
                        matTooltipTouchGestures="off">Zoom ≥ {{ osmNodesMinZoom }}</span>
                    </div>
                    <span class="layer-count-badge" *ngIf="getLayerInfo(layerId).featureCount != null"
                      [matTooltip]="getLayerCountTooltip(layerId)"
                      matTooltipPosition="above"
                      matTooltipTouchGestures="off">{{ getLayerInfo(layerId).featureCount }}</span>
                  </div>
                  <div class="layer-controls-right" *ngIf="!isOverlayLayer(layerId) && selectedLayerId !== layerId">
                    <button 
                      type="button"
                      class="icon-btn-small" 
                      (click)="zoomToLayer(layerId); $event.stopPropagation()"
                      matTooltip="Zoom to layer"
                      matTooltipPosition="above"
                      matTooltipTouchGestures="off"
                      aria-label="Zoom to layer">🔍</button>
                    <button 
                      type="button"
                      class="icon-btn-small" 
                      (click)="editLayerProperties(layerId); $event.stopPropagation()"
                      matTooltip="Layer settings"
                      matTooltipPosition="above"
                      matTooltipTouchGestures="off"
                      aria-label="Layer settings">⚙️</button>
                  </div>
                </div>
                <div class="layer-expanded-controls" *ngIf="selectedLayerId === layerId && !isOverlayLayer(layerId)"
                  (click)="$event.stopPropagation()"
                  (mousedown)="$event.stopPropagation()">
                  <div class="opacity-control">
                    <label matTooltip="Adjust layer opacity" matTooltipPosition="above" matTooltipTouchGestures="off">Opacity</label>
                    <input 
                      type="range" 
                      min="0" 
                      max="100" 
                      [value]="Math.round(getLayerInfo(layerId).opacity * 100)"
                      (input)="setLayerOpacityEnhanced(layerId, $any($event.target).value / 100)"
                      (click)="$event.stopPropagation()"
                      class="opacity-slider"
                      aria-label="Adjust opacity">
                    <span class="opacity-value">{{ Math.round(getLayerInfo(layerId).opacity * 100) }}%</span>
                  </div>
                  <div class="layer-minimized-controls">
                    <button type="button" class="btn-small" (click)="zoomToLayer(layerId); $event.stopPropagation()" matTooltip="Zoom to layer" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Zoom to layer">🔍</button>
                    <button type="button" class="btn-small" (click)="editLayerProperties(layerId); $event.stopPropagation()" matTooltip="Layer settings" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Layer settings">⚙️</button>
                    <button type="button" class="btn-small" (click)="moveLayerUp(layerId); $event.stopPropagation()" matTooltip="Move layer up" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Move layer up">↑</button>
                    <button type="button" class="btn-small" (click)="moveLayerDown(layerId); $event.stopPropagation()" matTooltip="Move layer down" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Move layer down">↓</button>
                    <button type="button" class="btn-small" (click)="duplicateLayer(layerId, layerId + '_copy'); $event.stopPropagation()" matTooltip="Duplicate layer" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Duplicate layer">📋</button>
                    <button type="button" class="btn-small danger" (click)="deleteLayer(layerId); $event.stopPropagation()" matTooltip="Delete layer" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Delete layer">🗑️</button>
                  </div>
                </div>
                <div class="layer-overlay-detail" *ngIf="selectedLayerId === layerId && isOverlayLayer(layerId)">
                  <span class="layer-overlay-detail__text" [title]="getLayerFullLabel(layerId)">{{ getLayerFullLabel(layerId) }}</span>
                  <span class="layer-overlay-detail__status" *ngIf="osmNetworkStatus && layerId === 'osm_road_network'" [title]="osmNetworkStatus">{{ osmNetworkStatus }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ungrouped-layers-container">
          <div 
            *ngFor="let layerId of getUngroupedLayers(); trackBy: trackByLayerId"
            class="layer-item"
            [class.selected]="selectedLayerId === layerId"
            [class.layer-item--overlay]="isOverlayLayer(layerId)"
            [class.locked]="isLayerLocked(layerId)"
            (contextmenu)="showLayerContextMenu($event, layerId)">
            <div class="layer-row" (click)="selectLayer(layerId)">
              <div class="layer-controls-left">
                <label class="layer-visibility-toggle"
                  [matTooltip]="getLayerVisibilityTooltip(layerId)"
                  matTooltipPosition="above"
                  matTooltipTouchGestures="off"
                  (click)="$event.stopPropagation()">
                  <input 
                    type="checkbox" 
                    [checked]="getLayerInfo(layerId).visible"
                    [disabled]="layerId === 'osm_vertex_nodes' && !osmNetworkEnabled"
                    (change)="toggleLayerEnhanced(layerId, $any($event.target).checked)"
                    (click)="$event.stopPropagation()">
                  <span class="checkmark"></span>
                </label>
                <span class="layer-icon"
                  [matTooltip]="getLayerFullLabel(layerId)"
                  matTooltipPosition="above"
                  matTooltipTouchGestures="off">{{ getLayerIcon(layerId) }}</span>
                <div class="layer-label-block">
                  <span class="layer-name"
                    [matTooltip]="getLayerNameTooltip(layerId)"
                    matTooltipPosition="above"
                    matTooltipTouchGestures="off">{{ getLayerDisplayName(layerId) }}</span>
                  <span class="layer-meta" *ngIf="layerId === 'osm_vertex_nodes'"
                    [matTooltip]="'Vertex nodes appear at zoom ' + osmNodesMinZoom + ' or higher'"
                    matTooltipPosition="above"
                    matTooltipTouchGestures="off">Zoom ≥ {{ osmNodesMinZoom }}</span>
                </div>
                <span class="layer-count-badge" *ngIf="getLayerInfo(layerId).featureCount != null"
                  [matTooltip]="getLayerCountTooltip(layerId)"
                  matTooltipPosition="above"
                  matTooltipTouchGestures="off">{{ getLayerInfo(layerId).featureCount }}</span>
              </div>
              <div class="layer-controls-right" *ngIf="!isOverlayLayer(layerId) && selectedLayerId !== layerId">
                <button 
                  type="button"
                  class="icon-btn-small" 
                  (click)="zoomToLayer(layerId); $event.stopPropagation()"
                  matTooltip="Zoom to layer"
                  matTooltipPosition="above"
                  matTooltipTouchGestures="off"
                  aria-label="Zoom to layer">🔍</button>
                <button 
                  type="button"
                  class="icon-btn-small" 
                  (click)="editLayerProperties(layerId); $event.stopPropagation()"
                  matTooltip="Layer settings"
                  matTooltipPosition="above"
                  matTooltipTouchGestures="off"
                  aria-label="Layer settings">⚙️</button>
              </div>
            </div>
            <div class="layer-expanded-controls" *ngIf="selectedLayerId === layerId && !isOverlayLayer(layerId)"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()">
              <div class="opacity-control">
                <label matTooltip="Adjust layer opacity" matTooltipPosition="above" matTooltipTouchGestures="off">Opacity</label>
                <input 
                  type="range" 
                  min="0" 
                  max="100" 
                  [value]="Math.round(getLayerInfo(layerId).opacity * 100)"
                  (input)="setLayerOpacityEnhanced(layerId, $any($event.target).value / 100)"
                  (click)="$event.stopPropagation()"
                  class="opacity-slider"
                  aria-label="Adjust opacity">
                <span class="opacity-value">{{ Math.round(getLayerInfo(layerId).opacity * 100) }}%</span>
              </div>
              <div class="layer-minimized-controls">
                <button type="button" class="btn-small" (click)="zoomToLayer(layerId); $event.stopPropagation()" matTooltip="Zoom to layer" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Zoom to layer">🔍</button>
                <button type="button" class="btn-small" (click)="editLayerProperties(layerId); $event.stopPropagation()" matTooltip="Layer settings" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Layer settings">⚙️</button>
                <button type="button" class="btn-small" (click)="moveLayerUp(layerId); $event.stopPropagation()" matTooltip="Move layer up" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Move layer up">↑</button>
                <button type="button" class="btn-small" (click)="moveLayerDown(layerId); $event.stopPropagation()" matTooltip="Move layer down" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Move layer down">↓</button>
                <button type="button" class="btn-small" (click)="duplicateLayer(layerId, layerId + '_copy'); $event.stopPropagation()" matTooltip="Duplicate layer" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Duplicate layer">📋</button>
                <button type="button" class="btn-small danger" (click)="deleteLayer(layerId); $event.stopPropagation()" matTooltip="Delete layer" matTooltipPosition="above" matTooltipTouchGestures="off" aria-label="Delete layer">🗑️</button>
              </div>
            </div>
            <div class="layer-overlay-detail" *ngIf="selectedLayerId === layerId && isOverlayLayer(layerId)">
              <span class="layer-overlay-detail__text" [title]="getLayerFullLabel(layerId)">{{ getLayerFullLabel(layerId) }}</span>
              <span class="layer-overlay-detail__status" *ngIf="osmNetworkStatus && layerId === 'osm_road_network'" [title]="osmNetworkStatus">{{ osmNetworkStatus }}</span>
            </div>
          </div>
        </div>
        <div class="sidebar-section basemap-section layers-tab-basemap">
          <h3>🗺 Base Map</h3>
          <div class="basemap-control">
            <select id="baseMapSelect" class="basemap-select" (change)="onBaseMapSelect($event)" title="Choose a base map">
              <optgroup label="Street">
                <option value="google">Google Streets</option>
                <option value="osm">OpenStreetMap</option>
              </optgroup>
              <optgroup label="Satellite &amp; terrain">
                <option value="googleSatellite">Google Satellite</option>
                <option value="googleHybrid">Google Hybrid</option>
                <option value="googleTerrain">Google Terrain</option>
                <option value="satellite">ESRI Satellite</option>
                <option value="terrain">ESRI Topo</option>
              </optgroup>
              <optgroup label="Other">
                <option value="dark">Dark</option>
                <option value="custom">Custom XYZ…</option>
              </optgroup>
            </select>
          </div>
          <div class="basemap-quick" role="group" aria-label="Quick base map">
            <button type="button" class="basemap-pill" [class.active]="selectedBaseMapKey === 'google'" (click)="pickBaseMap('google')" title="Google Streets">Street</button>
            <button type="button" class="basemap-pill" [class.active]="selectedBaseMapKey === 'googleSatellite'" (click)="pickBaseMap('googleSatellite')" title="Google Satellite">Sat</button>
            <button type="button" class="basemap-pill" [class.active]="selectedBaseMapKey === 'googleHybrid'" (click)="pickBaseMap('googleHybrid')" title="Google Hybrid">Hybrid</button>
            <button type="button" class="basemap-pill" [class.active]="selectedBaseMapKey === 'googleTerrain'" (click)="pickBaseMap('googleTerrain')" title="Google Terrain">Terrain</button>
          </div>
          <p class="osm-network-hint" *ngIf="osmNetworkStatus" [title]="osmNetworkStatus">{{ osmNetworkStatus }}</p>
        </div>
        <div class="no-layers-found" *ngIf="layerOrder.length === 0">
          <p>No layers found. Add a new layer to get started.</p>
        </div>
      </div>
    </div>

    <!-- Drawing Tab -->
    <div class="tab-content active" id="drawing-tab">
      <div class="sidebar-section">
        <h3>🎯 Drawing Tools</h3>
        <div class="control-group">
          <label>Drawing Mode:</label>
          <select id="drawingMode">
            <option value="">Select Tool</option>
            <option value="Point">Point Marker</option>
            <option value="MilestoneTag">Milestone Tag (Clickable)</option>
            <option value="LineString">Single Line</option>
            <option value="ProposedAlignment">Proposed Alignment (Green)</option>
            <option value="AlternateRoute">Alternate Route (Orange Dashed)</option>
            <option value="ExistingRoad">Existing Road (Gray)</option>
            <option value="MultiLineString">Multiple Lines</option>
            <option value="Polygon">Area/Polygon</option>
            <option value="Circle">Circle</option>
            <option value="CurveLine">Curve Line</option>
            <option value="Text">Add Text</option>
            <option value="GasDuct">Gas Duct</option>
            <option value="ElectricityDuct">Electricity Duct</option>
            <option value="TelecomDuct">Telecom Duct</option>
          </select>
        </div>

        <div class="draw-range-row">
          <span class="draw-range-row__label">Line Size</span>
          <input
            type="range"
            id="lineThickness"
            class="opacity-slider draw-range"
            min="1"
            max="20"
            step="1"
            [value]="lineThickness"
            (input)="onLineThicknessChange($event)"
            aria-label="Line size"
          />
          <span id="thicknessValue" class="draw-range-row__val">{{ lineThickness }}px</span>
        </div>

        <div class="draw-range-row">
          <span class="draw-range-row__label">Symbol Size</span>
          <input
            type="range"
            id="symbolSize"
            class="opacity-slider draw-range"
            min="0.5"
            max="3"
            step="0.1"
            [value]="symbolSize"
            (input)="onSymbolSizeChange($event)"
            aria-label="Symbol size"
          />
          <span id="symbolSizeValue" class="draw-range-row__val">{{ symbolSize }}x</span>
        </div>

        <label class="checkbox-inline freehand-label">
          <input type="checkbox" id="freehandMode" [checked]="freehandMode" (change)="freehandMode = $any($event.target).checked; handleDrawingModeChange(currentDrawingMode)">
          <span>Freehand (lines/polygons)</span>
        </label>

        <div class="control-group">
          <label style="color: white; font-size: 10px;">Custom icon URL (SVG/PNG):</label>
          <input type="url" id="customIconUrl" placeholder="https://... or data:image/..." style="width: 100%; margin-top: 2px; font-size: 10px;"
            [value]="defaultIconUrl" (input)="defaultIconUrl = $any($event.target).value">
        </div>

        <div class="text-tool">
          <label style=" font-size: 10px;">Text Content:</label>
          <input type="text" id="textContent" placeholder="Enter text" style="width: 100%; margin-top: 4px;color: black;">
          <div style="display: flex; gap: 4px; margin-top: 4px;">
            <input type="color" id="textColor" value="#000000">
            <select id="textSize" style="flex: 1;">
              <option value="12">12px</option>
              <option value="14" selected>14px</option>
              <option value="16">16px</option>
              <option value="18">18px</option>
              <option value="24">24px</option>
            </select>
          </div>
        </div>

        <div class="text-tool">
          <label style="font-size: 10px;">Milestone Tag:</label>
          <input type="text" id="milestoneLabel" placeholder="e.g. Tender Analysis" style="width: 100%; margin-top: 4px; color: black;">
          <div style="display: flex; gap: 4px; margin-top: 4px;">
            <select id="milestoneCategory" style="flex: 1;">
              <option value="tender">Tender</option>
              <option value="survey">Survey</option>
              <option value="design">Design</option>
              <option value="progress">Progress</option>
              <option value="general" selected>General</option>
            </select>
            <input type="text" id="milestoneChainage" placeholder="CH 120+000" style="flex: 1; color: black;">
          </div>
          <div style="display: flex; gap: 4px; margin-top: 4px; align-items: center;">
            <label style="font-size: 9px; color: #bdc3c7; min-width: 95px;">Chainage Interval</label>
            <input type="number" id="milestoneChainageInterval" value="500" min="50" step="50" style="flex: 1; color: black;" title="Meters between chainage labels">
            <span style="font-size: 9px; color: #bdc3c7;">m</span>
          </div>
          <div style="font-size: 9px; margin-top: 4px; color: #bdc3c7;">
            Select <b>Milestone Tag</b> tool, click map to place, click tag to edit.
          </div>
        </div>

        <div class="coordinate-input">
          <h4 style="color: white; font-size: 11px; margin: 8px 0 4px 0;">📍 Pinpoint Location</h4>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Latitude:</label>
            <input type="number" id="latitudeInput" placeholder="28.6139" step="0.000001" min="-90" max="90" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Longitude:</label>
            <input type="number" id="longitudeInput" placeholder="77.2090" step="0.000001" min="-180" max="180" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="btn-group" style="margin-top: 6px;">
            <button class="btn" id="pinpointLocation" style="width: 100%; font-size: 10px;">🎯 Go to Location</button>
          </div>
          <div class="btn-group" style="margin-top: 4px;">
            <button class="btn" id="addMarkerAtLocation" style="width: 100%; font-size: 10px;">📍 Add Marker</button>
          </div>
          <div style="font-size: 8px; color: #bdc3c7; margin-top: 4px;">
            Current: <span id="currentCoords">28.6139, 77.2090</span>
          </div>
        </div>

        <div class="asset-type">
          <label>Asset Type:</label>
          <select id="assetType">
            <option value="overground">Overground</option>
            <option value="underground">Underground</option>
            <option value="crossover">Crossover</option>
          </select>
        </div>

        <div class="checkbox-stack">
          <label class="checkbox-inline">
            <input type="checkbox" id="showNomenclature" checked>
            <span>Show Nomenclature</span>
          </label>
          <label class="checkbox-inline">
            <input type="checkbox" id="showOverground" checked>
            <span>Show Overground Assets</span>
          </label>
          <label class="checkbox-inline">
            <input type="checkbox" id="showUnderground" checked>
            <span>Show Underground Assets</span>
          </label>
          <label class="checkbox-inline">
            <input type="checkbox" id="showCrossover" checked>
            <span>Show Crossover Assets</span>
          </label>
        </div>
      </div>

      <!-- Add Layers (in Draw tab) -->
      <div class="sidebar-section layers-in-tab">
        <h3>🗂️ Layers</h3>
        <div class="layer-toolbar-inline">
          <button type="button" class="btn btn-add-layer" (click)="showCreateLayerDialog()" title="Add New Layer">
            <span class="icon">➕</span> Add Layer
          </button>
          <button type="button" class="btn btn-secondary-inline" (click)="showImportLayerDialogWrapper()" title="Import Layer">
            <span class="icon">📁</span> Import
          </button>
        </div>
        <button type="button" class="btn-link" (click)="switchToLayersTab()" title="Open layer list">
          Manage layers…
        </button>
      </div>

      <div class="sidebar-section">
        <h3>📊 Segment Management</h3>
        <div class="numbering-controls">
          <label style="color: white; font-size: 10px;">Numbering Type:</label>
          <select id="numberingType" style="margin-top: 4px;">
            <option value="auto">Auto Numbering</option>
            <option value="manual">Manual Numbering</option>
          </select>
          <div class="control-group" style="margin-top: 6px;">
            <label style="color: white; font-size: 9px;">Nomenclature:</label>
            <input type="text" id="nomenclature" placeholder="any name" value="" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Abbreviation:</label>
            <input type="text" id="nomenclatureAbbreviation" placeholder="Gb" value="Gb" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Start Number:</label>
            <input type="number" id="startNumber" value="1" min="1" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="segment-controls">
            <button class="btn" id="startSegmentDrawing">🎯 Start Drawing</button>
            <button class="btn" id="stopSegmentDrawing" style="display: none;">⏹️ Stop Drawing</button>
            <button class="btn" id="resetNumbers">🔄 Reset #</button>
          </div>
        </div>
        <div style="font-size: 9px; color: #bdc3c7;">
          Current: Node <span id="nodeCounter">1</span>, Segment <span id="segmentCounter">1</span>
        </div>
        <div class="control-group" style="margin-top: 8px;">
          <label>Manual Node #:</label>
          <input type="number" id="manualNodeNumber" min="1" value="1" style="width: 60px;">
        </div>
        <div class="control-group">
          <label>Manual Segment #:</label>
          <input type="number" id="manualSegmentNumber" min="1" value="1" style="width: 60px;">
        </div>
        <div class="control-group">
          <label>Segment Comment:</label>
          <input type="text" id="segmentComment" placeholder="Enter comment">
          <button class="btn" id="addComment">Add Comment</button>
        </div>
        <div class="drawing-instructions" id="drawingInstructions">
          <strong>Instructions:</strong><br>
          • Click "Start Drawing" to begin<br>
          • Click on map to place nodes<br>
          • Segments are drawn between consecutive nodes<br>
          • Double-click to finish drawing<br>
          • Right-click to cancel
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🔗 Road Junctions & Circles</h3>
        <div class="junction-grid">
          <div class="junction-btn" data-junction="1" title="One Way">
            <span class="ji-bar ji-bar--h-wide"></span>
            <span class="ji-arrow ji-arrow--end">→</span>
          </div>
          <div class="junction-btn" data-junction="2" title="Two Way">
            <span class="ji-bar ji-bar--h-wide"></span>
            <span class="ji-arrow ji-arrow--end">↔</span>
          </div>
          <div class="junction-btn" data-junction="3" title="3-Way Junction">
            <span class="ji-bar ji-bar--cross-h"></span>
            <span class="ji-bar ji-bar--cross-v-short"></span>
            <span class="ji-num">3</span>
          </div>
          <div class="junction-btn" data-junction="4" title="4-Way Junction">
            <span class="ji-bar ji-bar--cross-h"></span>
            <span class="ji-bar ji-bar--cross-v"></span>
            <span class="ji-num">4</span>
          </div>
          <div class="junction-btn" data-junction="5" title="5-Way Junction">
            <span class="ji-bar ji-bar--cross-h-sm"></span>
            <span class="ji-bar ji-bar--cross-v-sm"></span>
            <span class="ji-bar ji-bar--diag"></span>
            <span class="ji-num">5</span>
          </div>
          <div class="junction-btn" data-junction="roundabout" title="Roundabout/Circle">
            <span class="ji-ring"></span>
          </div>
        </div>
        <div class="btn-group" style="margin-top: 8px;">
          <button class="btn" id="connectRoadToJunction">🔗 Connect Road</button>
          <button class="btn" id="connectSegments">⛓️ Connect Segments</button>
          <button class="btn" id="splitSegment">✂️ Split Segment</button>
          <button class="btn" id="highlightJunctionsBtn" title="Detect and highlight line intersections">🔀 Highlight Intersections</button>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🔄 Overlay Controls</h3>
        <div class="overlay-controls">
          <button class="btn" id="overlayRoads">Overlay Roads</button>
          <button class="btn" id="bridgeOverlay">🌉 Bridge Overlay</button>
          <button class="btn" id="clearOverlay">Clear Overlay</button>
        </div>
        <div class="control-group">
          <label>Overlay Opacity:</label>
          <input type="range" id="overlayOpacity" min="0" max="100" value="50">
        </div>
        <div class="offset-control">
          <label>Layer Offset (pixels):</label>
          <input type="number" id="layerOffsetX" placeholder="X" style="width: 45%; margin-right: 10%;">
          <input type="number" id="layerOffsetY" placeholder="Y" style="width: 45%;">
          <button class="btn" id="applyOffset">Apply</button>
        </div>
      </div>
    </div>

    <!-- Road Infrastructure Tab -->
    <div class="tab-content" id="road-tab">
      <div class="sidebar-section">
        <h3>🛣️ Road Infrastructure</h3>
        <button class="btn" id="symbolPopupBtn">Select Symbol</button>
        <div class="symbol-grid" id="symbolGrid" style="display: none;">
          <div class="symbol-btn" data-symbol="🛣️" title="Main Road">🛣️</div>
          <div class="symbol-btn" data-symbol="🛤️" title="Side Road">🛤️</div>
          <div class="symbol-btn" data-symbol="🌉" title="Bridge">🌉</div>
          <div class="symbol-btn" data-symbol="🚧" title="Construction">🚧</div>
          <div class="symbol-btn" data-symbol="🚏" title="Bus Stop">🚏</div>
          <div class="symbol-btn" data-symbol="⛽" title="Fuel Station">⛽</div>
          <div class="symbol-btn" data-symbol="🏪" title="Toll Plaza">🏪</div>
          <div class="symbol-btn" data-symbol="🚦" title="Traffic Light">🚦</div>
          <div class="symbol-btn" data-symbol="🛑" title="Stop Sign">🛑</div>
          <div class="symbol-btn" data-symbol="⚠️" title="Warning Sign">⚠️</div>
          <div class="symbol-btn" data-symbol="📍" title="Milestone">📍</div>
          <div class="symbol-btn" data-symbol="🏃" title="Pedestrian">🏃</div>
          <div class="symbol-btn" data-symbol="🌊" title="Nalla/Drain">🌊</div>
          <div class="symbol-btn" data-symbol="🌳" title="Tree">🌳</div>
          <div class="symbol-btn" data-symbol="🏠" title="Building">🏠</div>
          <div class="symbol-btn" data-symbol="⚡" title="Power Line">⚡</div>
          <div class="symbol-btn" data-symbol="📐" title="Survey Point">📐</div>
          <div class="symbol-btn" data-symbol="🚩" title="Flag Point">🚩</div>
          <div class="symbol-btn" data-symbol="⭕" title="Circle Marker">⭕</div>
          <div class="symbol-btn" data-symbol="🔺" title="Triangle">🔺</div>
          <div class="symbol-btn" data-symbol="🔳" title="Square">🔳</div>
          <div class="symbol-btn" data-symbol="💎" title="Diamond">💎</div>
          <div class="symbol-btn" data-symbol="⭐" title="Star">⭐</div>
          <div class="symbol-btn" data-symbol="🎯" title="Target">🎯</div>
          <div class="symbol-btn" data-symbol="🔌" title="Electricity Junction">🔌</div>
          <div class="symbol-btn" data-symbol="📡" title="Telecom Junction">📡</div>
        </div>
        <div class="thematic-selector">
          <label>Layer Thematic:</label>
          <select id="layerThematic">
            <option value="default">Default</option>
            <option value="heat">Heat Map</option>
            <option value="cluster">Cluster</option>
          </select>
        </div>
        <div class="btn-group" style="margin-top: 6px;">
          <button type="button" class="btn" id="toggleHeatmapOverlayBtn" title="Toggle density heatmap overlay">🗺️ Heatmap Overlay</button>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🛣️ Multi-Lane Road Symbols</h3>
        <div class="symbol-grid">
          <div class="symbol-btn" data-symbol="🛣️2" title="2-Lane Road">2️⃣</div>
          <div class="symbol-btn" data-symbol="🛣️4" title="4-Lane Road">4️⃣</div>
          <div class="symbol-btn" data-symbol="🛣️6" title="6-Lane Road">6️⃣</div>
          <div class="symbol-btn" data-symbol="🛣️8" title="8-Lane Road">8️⃣</div>
          <div class="symbol-btn" data-symbol="↗️" title="Sideway Road">↗️</div>
          <div class="symbol-btn" data-symbol="💧" title="Water Exit">💧</div>
        </div>
      </div>

      <div class="sidebar-section road-project-sync">
        <h3>↗ Project quantities</h3>
        <p class="road-project-sync__hint">
          Update this road project's length, lanes, width, and mapped footprint from the road alignment or active LRS centerline.
        </p>
        <button
          type="button"
          class="btn road-project-sync__button"
          (click)="pushGisMetricsToProject()"
          [disabled]="!projectId || gisMetricsSaving"
          [title]="projectId ? 'Update this project from the map geometry' : 'Open a road project first'"
        >
          {{ gisMetricsSaving ? 'Updating project…' : 'Update project from GIS' }}
        </button>
        <p class="road-project-sync__status" *ngIf="!projectId">Open this editor from a road project to enable sync.</p>
        <p class="road-project-sync__status" *ngIf="lastGisMetricSummary && projectId">
          {{ lastGisMetricSummary.roadFeatureCount }} alignment{{ lastGisMetricSummary.roadFeatureCount === 1 ? '' : 's' }}
          · {{ lastGisMetricSummary.areaFeatureCount }} area{{ lastGisMetricSummary.areaFeatureCount === 1 ? '' : 's' }}
          · {{ lastGisMetricSummary.source === 'lrs-centerline' ? 'LRS centerline' : 'map alignment' }}
        </p>
      </div>

      <div class="sidebar-section road-project-sync">
        <h3>Publish to LRS / RoadGraph</h3>
        <p class="road-project-sync__hint">
          Persist junctions + alignments as a RoadGraph (desk L1), or publish the active centerline as an LRS route (desk L3).
        </p>
        <button
          type="button"
          class="btn road-project-sync__button"
          (click)="publishRoadGraph()"
          [disabled]="!projectId || deskPublishBusy"
        >
          {{ deskPublishBusy ? 'Publishing…' : 'Publish road graph' }}
        </button>
        <button
          type="button"
          class="btn road-project-sync__button"
          (click)="publishAlignmentToLrs()"
          [disabled]="deskPublishBusy"
          style="margin-top: 6px;"
        >
          Publish alignment to LRS
        </button>
        <button
          type="button"
          class="btn"
          (click)="validateRoadGraphTopology()"
          [disabled]="!projectId"
          style="margin-top: 6px;"
        >
          Validate topology (Network QC)
        </button>
        <p class="road-project-sync__status" *ngIf="deskPublishStatus">{{ deskPublishStatus }}</p>
      </div>

      <div class="sidebar-section">
        <h3>📏 3D View & Measurements</h3>
        <div class="d3-controls">
          <button class="btn" id="enable3D" style="width: 100%; margin-bottom: 4px;">🎮 Enable 3D View</button>
          <div style="display: flex; gap: 4px;">
            <button class="btn" id="viewTop">Top</button>
            <button class="btn" id="viewSide">Side</button>
            <button class="btn" id="viewAngle">Angle</button>
          </div>
          <div class="control-group">
            <label>3D Height Scale:</label>
            <input type="range" id="heightScale" min="1" max="10" value="3">
          </div>
          <div class="control-group">
            <label>Show Elevation:</label>
            <input type="checkbox" id="showElevation" checked>
          </div>
          <div class="control-group">
            <button class="btn" id="elevationProfile" style="width: 100%;">📈 Elevation Profile</button>
          </div>
        </div>
        <div class="control-group">
          <button class="btn" id="pointDistance" style="width: 100%;">Point-to-Point Distance</button>
        </div>
        <div class="control-group">
          <button class="btn" id="endToEndDistance" style="width: 100%;">End-to-End Distance</button>
        </div>
        <div class="control-group">
          <button class="btn" id="calculateGeometry" style="width: 100%;">📐 Calculate Area & Length</button>
        </div>
        <button class="btn snapshot-btn" id="takeSnapshot">📸 Take Snapshot</button>
        <button class="btn gps-error-btn" id="calculateGpsError">📡 Calculate GPS Error</button>
      </div>
    </div>

    <!-- Advanced Tab -->
    <div class="tab-content" id="advanced-tab">
      <div class="sidebar-section">
        <h3>🛣️ Road Specifications</h3>
        <div class="road-specifications">
          <div class="road-spec-row">
            <label style="color: white; font-size: 9px;">Road Type:</label>
            <select id="roadType">
              <option value="highway">Highway</option>
              <option value="arterial">Arterial</option>
              <option value="collector">Collector</option>
              <option value="local">Local Street</option>
              <option value="service">Service Road</option>
            </select>
          </div>
          <div class="road-spec-row">
            <label style="color: white; font-size: 9px;">Width (m):</label>
            <input type="number" id="roadWidth" min="3" max="50" value="12" step="0.5">
            <label style="color: white; font-size: 9px;">Depth (m):</label>
            <input type="number" id="roadDepth" min="0.1" max="5" value="0.5" step="0.1">
          </div>
          <div class="road-spec-row">
            <label style="color: white; font-size: 9px;">Lanes:</label>
            <select id="roadLanes">
              <option value="1">Single Lane</option>
              <option value="2">2 Lanes</option>
              <option value="4">4 Lanes</option>
              <option value="6">6 Lanes</option>
              <option value="8">8 Lanes</option>
            </select>
          </div>
          <div class="road-spec-row">
            <label style="color: white; font-size: 9px;">Surface Type:</label>
            <select id="surfaceType">
              <option value="bituminous">Bituminous</option>
              <option value="concrete">Concrete</option>
              <option value="gravel">Gravel</option>
              <option value="earthen">Earthen</option>
            </select>
          </div>
          <div class="road-spec-row" style="margin-top: 6px;">
            <button class="btn" id="generateDummyRoadInfra" style="width: 100%;"> Generate Road</button>
          </div>
          <div class="road-spec-row" style="margin-top: 4px;">
            <button class="btn" id="drawManualRoadCorridor" style="width: 100%;"> Draw Road (manual)</button>
          </div>
          <div class="road-spec-row" style="margin-top: 4px;">
            <button class="btn" id="clearDummyRoadInfra" style="width: 100%;"> Clear Road</button>
          </div>
          <div class="road-spec-hint" style="font-size: 8px; color: #bdc3c7; margin-top: 4px; line-height: 1.3;">
            Draw Road: uses Road Specifications and Lane Separators above — click to trace centerline, double-click to finish.
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🏗️ Lane Separators</h3>
        <div class="separator-controls">
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Divider Type:</label>
            <select id="dividerType" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option *ngFor="let opt of roadDividerOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
          </div>
          <div class="lane-separator">
            <label style="color: white; font-size: 9px;">Separator Distance (m):</label>
            <input type="number" id="separatorDistance" min="0.5" max="10" value="2" step="0.5" style="width: 100%; margin-top: 2px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Median / Divider Width (m):</label>
            <input type="number" id="separatorWidth" min="0" max="5" value="0.3" step="0.1" style="width: 100%; margin-top: 2px;">
          </div>
          <div class="btn-group" style="margin-top: 6px;">
            <button class="btn" id="insertSeparator">➕ Insert Separator</button>
            <button class="btn" id="calculateSeparator">📐 Calculate</button>
          </div>
          <div style="font-size: 8px; color: #ecf0f1; margin-top: 4px;">
            Total Separators: <span id="separatorCount">0</span>
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🎨 Advanced Drawing</h3>
        <div class="advanced-drawing">
          <div class="control-group">
            <label style="color: white; font-size: 10px;">Curve Type:</label>
            <select id="curveType" style="width: 100%; margin-top: 4px; font-size: 10px;">
              <option value="smooth">Smooth Curve</option>
              <option value="bezier">Bézier Curve</option>
              <option value="spline">Spline Curve</option>
              <option value="arc">Arc Curve</option>
            </select>
          </div>
          <div class="curve-controls">
            <button class="btn" id="startCurveDrawing">🎯 Start Curve</button>
            <button class="btn" id="finishCurveDrawing" style="display: none;"> Finish</button>
            <button class="btn" id="cancelCurveDrawing" style="display: none;">❌ Cancel</button>
          </div>
          <div class="control-group" style="margin-top: 6px;">
            <label style="color: white; font-size: 9px;">Curve Precision:</label>
            <input type="range" id="curvePrecision" min="10" max="100" value="30">
            <span id="precisionValue" style="color: white; font-size: 8px;">30</span>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Control Points:</label>
            <input type="checkbox" id="showControlPoints" checked> Show Control Points
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Smoothness:</label>
            <input type="range" id="curveSmoothness" min="0.1" max="2" step="0.1" value="1">
            <span id="smoothnessValue" style="color: white; font-size: 8px;">1.0</span>
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🌊 Water Features</h3>
        <div class="symbol-grid">
          <div class="symbol-btn" data-symbol="🌊" title="Nalla/Stream">🌊</div>
          <div class="symbol-btn" data-symbol="💧" title="Water Exit">💧</div>
          <div class="symbol-btn" data-symbol="🌉" title="Culvert">🌉</div>
          <div class="symbol-btn" data-symbol="🔄" title="Water Flow">🔄</div>
        </div>
        <div class="btn-group" style="margin-top: 6px;">
          <button class="btn" id="drawNalla">🌊 Draw Nalla</button>
          <button class="btn" id="addWaterExit">💧 Water Exit</button>
          <button class="btn" id="addCulvert">🌉 Add Culvert</button>
        </div>
        <div class="control-group" style="margin-top: 8px;">
          <label style="color: white; font-size: 9px;">Water Flow Direction:</label>
          <select id="waterFlowDirection" style="width: 100%; margin-top: 2px; font-size: 10px;">
            <option value="north">North</option>
            <option value="south">South</option>
            <option value="east">East</option>
            <option value="west">West</option>
            <option value="northeast">Northeast</option>
            <option value="northwest">Northwest</option>
            <option value="southeast">Southeast</option>
            <option value="southwest">Southwest</option>
          </select>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>📊 Advanced Analysis</h3>
        <div class="analysis-controls">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="analyzeRoadNetwork">🛣️ Road Network</button>
            <button class="btn" id="analyzeTrafficFlow">🚗 Traffic Flow</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="analyzeDrainage">🌊 Drainage</button>
            <button class="btn" id="analyzeElevation">⛰️ Elevation</button>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Analysis Buffer (m):</label>
            <input type="number" id="analysisBuffer" min="10" max="1000" value="100" step="10" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Analysis Type:</label>
            <select id="analysisType" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option value="intersection">Intersection Analysis</option>
              <option value="connectivity">Connectivity Analysis</option>
              <option value="density">Density Analysis</option>
              <option value="accessibility">Accessibility Analysis</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>💾 Export/Import</h3>
        <div class="export-import-controls">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="exportRoadSpecs">📋 Road Specs</button>
            <button class="btn" id="exportAnalysis">📊 Analysis</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="importCAD">📐 Import CAD</button>
            <button class="btn" id="importGIS">🗺️ Import GIS</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="loadContourBtn" title="Load contour lines from GeoJSON">📈 Load Contour GeoJSON</button>
            <button class="btn" id="addDemLayerBtn" title="Add DEM tile layer (enter URL)">⛰️ Add DEM Layer</button>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Export Format:</label>
            <select id="exportFormat" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option value="geojson">GeoJSON</option>
              <option value="kml">KML</option>
              <option value="shp">Shapefile</option>
              <option value="dxf">DXF</option>
              <option value="csv">CSV</option>
            </select>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Include Metadata:</label>
            <input type="checkbox" id="includeMetadata" checked> Include metadata
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🔧 Advanced Tools</h3>
        <div class="advanced-tools">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="autoGenerateRoads">🛣️ Auto Roads</button>
            <button class="btn" id="optimizeNetwork">⚡ Optimize</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="validateGeometry"> Validate</button>
            <button class="btn" id="repairGeometry">🔧 Repair</button>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Validation Rules:</label>
            <select id="validationRules" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option value="basic">Basic Validation</option>
              <option value="strict">Strict Validation</option>
              <option value="custom">Custom Rules</option>
            </select>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Auto-fix Issues:</label>
            <input type="checkbox" id="autoFixIssues" checked> Auto-fix when possible
          </div>
        </div>
      </div>
    </div>

    <!-- LRS Tab (linear referencing on shared map) -->
    <div class="tab-content lrs-sidebar-tab" id="lrs-tab" *ngIf="enableLrsTab">
      <app-lrs-manager
        [integratedMode]="true"
        [sidebarPanelOnly]="true"
        [mapInteractActive]="activeSidebarTab === 'lrs'"
      ></app-lrs-manager>
    </div>

    <!-- Survey Tab -->
    <div class="tab-content" id="survey-tab">
      <app-gis-project-mgmt-panel
        mode="survey"
        [projectId]="projectId"
        [projectData]="projectData"
        (mapAction)="onGisOpsMapAction($event)"
      ></app-gis-project-mgmt-panel>
      <div class="sidebar-section">
        <h3>📡 GPS & Field Survey</h3>
        <div class="project-info">
          <div><span class="status-indicator status-active"></span>GPS Active</div>
          <div>Accuracy: <span id="gpsAccuracy">5</span>m</div>
          <div>Survey Points: <span id="surveyPointCount">0</span></div>
        </div>
        <div class="btn-group">
          <button class="btn" id="enableGPS">📡 GPS On</button>
          <button class="btn" id="addSurveyPoint">📍 Survey Point</button>
          <button class="btn" id="addSurveyArea">📐 Survey Area</button>
          <button class="btn" type="button" (click)="saveFieldSurvey()">💾 Save field survey</button>
        </div>
      </div>

      <div class="sidebar-section">
        <h3> Acceptance Testing</h3>
        <div class="project-info">
          <div><span class="status-indicator status-pending"></span>Testing Phase</div>
          <div>Passed: <span id="testsPassed">0</span></div>
          <div>Failed: <span id="testsFailed">0</span></div>
          <div>Pending: <span id="testsPending">5</span></div>
        </div>
        <div class="btn-group">
          <button class="btn" id="passTest" style="background: #27ae60;"> Pass</button>
          <button class="btn" id="failTest" style="background: #e74c3c;">❌ Fail</button>
        </div>
      </div>
    </div>

    <!-- Management Tab -->
    <div class="tab-content" id="management-tab">
      <app-gis-project-mgmt-panel
        mode="full"
        [projectId]="projectId"
        [projectData]="projectData"
        (mapAction)="onGisOpsMapAction($event)"
      ></app-gis-project-mgmt-panel>
    </div>

    <!-- Biometric Tab -->
    <div class="tab-content" id="biometric-tab">
      <app-gis-project-mgmt-panel
        mode="attendance"
        [projectId]="projectId"
        [projectData]="projectData"
        (mapAction)="onGisOpsMapAction($event)"
      ></app-gis-project-mgmt-panel>

      <div class="sidebar-section">
        <h3>Geo-attendance tools</h3>
        <div class="project-info">
          <div>Draw a work zone, then plot live punches on the Biometric layer.</div>
        </div>
        <div class="btn-group">
          <button class="btn" id="setWorkZone">Set work zone</button>
          <button class="btn" id="trackWorkers">Track workers</button>
        </div>
      </div>
    </div>

    <!-- Analysis Tab -->
    <div class="tab-content" id="analysis-tab">
      <div class="sidebar-section">
        <h3>📊 Spatial Analysis</h3>
        <div class="analysis-tools">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="bufferAnalysis">🔵 Buffer Analysis</button>
            <button class="btn" id="intersectionAnalysis">🔀 Intersection</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="overlayAnalysis">📋 Overlay</button>
            <button class="btn" id="proximityAnalysis">📍 Proximity</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="networkAnalysis">🕸️ Network</button>
            <button class="btn" id="terrainAnalysis">⛰️ Terrain</button>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Analysis Buffer (m):</label>
            <input type="number" id="analysisBufferSize" min="1" max="10000" value="100" step="1" style="width: 100%; margin-top: 2px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Coordinate System:</label>
            <select id="coordinateSystem" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option value="EPSG:4326">WGS84 (EPSG:4326)</option>
              <option value="EPSG:3857">Web Mercator (EPSG:3857)</option>
              <option value="EPSG:32643">UTM Zone 43N</option>
              <option value="EPSG:32644">UTM Zone 44N</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>📈 Statistical Analysis</h3>
        <div class="statistical-tools">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="calculateArea">📐 Area Stats</button>
            <button class="btn" id="calculateLength">📏 Length Stats</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="densityAnalysis">📊 Density</button>
            <button class="btn" id="clusteringAnalysis">🔗 Clustering</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="hotspotAnalysis">🔥 Hotspots</button>
            <button class="btn" id="patternAnalysis">🎯 Patterns</button>
          </div>
          <div class="analysis-results" id="analysisResults" style="display: none; background: #34495e; padding: 8px; border-radius: 4px; margin-top: 6px; font-size: 10px;">
            <div><strong>Analysis Results:</strong></div>
            <div id="analysisResultsContent">No analysis performed</div>
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🗺️ Cartographic Tools</h3>
        <div class="cartographic-tools">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="generateMap">🗺️ Generate Map</button>
            <button class="btn" id="createLayout">📋 Layout</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="addLegend">🏷️ Add Legend</button>
            <button class="btn" id="addScale">📏 Add Scale</button>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Map Title:</label>
            <input type="text" id="mapTitle" placeholder="Enter map title" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Map Scale:</label>
            <select id="mapScale" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option value="1:1000">1:1,000</option>
              <option value="1:5000">1:5,000</option>
              <option value="1:10000">1:10,000</option>
              <option value="1:25000">1:25,000</option>
              <option value="1:50000">1:50,000</option>
              <option value="1:100000">1:100,000</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Management Tab -->
    <div class="tab-content" id="data-tab">
      <div class="sidebar-section">
        <h3>🎬 Technical Demo</h3>
        <div class="tech-demo-panel">
          <p class="demo-intro">Road + utility corridor demo — stacked cross-section, LRS chainage, geo-docs, BOM link.</p>
          <div class="control-group">
            <label>Chainage interval:</label>
            <select [value]="chainageIntervalM" (change)="setChainageIntervalM(+$any($event.target).value)">
              <option *ngFor="let m of chainageIntervalOptions" [value]="m">{{ m }} m</option>
            </select>
          </div>
          <label class="lrs-check">
            <input type="checkbox" [checked]="demoTerrainOn" (change)="toggleDemoTerrain($any($event.target).checked)" />
            Terrain / DEM overlay (OpenTopoMap)
          </label>
          <label class="lrs-check">
            <input type="checkbox" [checked]="demoShowOffsets" (change)="onDemoShowOffsetsChange($any($event.target).checked)" />
            Show lateral offset & depth labels
          </label>
          <label class="lrs-check">
            <input type="checkbox" [checked]="is3DMode" (change)="toggleDemo3DView()" />
            3D perspective + terrain (Z-axis view)
          </label>
          <button type="button" class="btn btn-primary btn-block" (click)="bootstrapTechnicalDemo()" [disabled]="demoLoading">
            {{ demoLoading ? 'Loading demo…' : '▶ Run technical demo' }}
          </button>
          <button type="button" class="btn btn-block" (click)="bootstrapLrsDemo()" style="margin-top: 6px;">
            ▶ One-click LRS demo
          </button>
          <div class="control-group" style="margin-top: 8px;">
            <label>Tag selected features to layer:</label>
            <select
              [value]="demoTagTargetLayerId"
              (change)="demoTagTargetLayerId = $any($event.target).value">
              <option *ngFor="let l of demoLayerOptions" [value]="l.id">{{ l.label }}</option>
            </select>
            <button type="button" class="btn btn-sm" (click)="assignSelectedToDemoLayer()">Assign to layer</button>
          </div>
          <div class="btn-group" style="margin-top: 6px;">
            <button type="button" class="btn" (click)="loadDemoBoqBom()" [disabled]="boqBomLoading">
              {{ boqBomLoading ? '…' : 'Load BOQ/BOM' }}
            </button>
            <button type="button" class="btn" (click)="openConstructionBoq()">BOQ module</button>
            <button type="button" class="btn" (click)="openConstructionBom()">BOM module</button>
          </div>
          <ul class="geodoc-list" *ngIf="boqList.length || bomList.length">
            <li *ngFor="let b of boqList">
              BOQ <button type="button" class="btn btn-ghost btn-sm" (click)="openDemoBoq(b.boq_id!)">{{ b.boq_name || b.boq_id }}</button>
            </li>
            <li *ngFor="let b of bomList">
              BOM <button type="button" class="btn btn-ghost btn-sm" (click)="openDemoBom(b.id!)">{{ b.bom_name || b.id }}</button>
            </li>
          </ul>
          <div class="lrs-status" *ngIf="demoStatus">{{ demoStatus }}</div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>📎 Documents &amp; LRS</h3>
        <div class="tech-demo-panel">
          <p class="geodoc-hint">Manage geo-tagged documents in the Document Library, then link them to routes via LRS chainage. Markers appear on the selected route.</p>
          <button type="button" class="btn btn-primary btn-block" (click)="openDocumentLibrary()">Open Document Library</button>
          <ul class="geodoc-list" *ngIf="lrsLinkedDocuments.length">
            <li
              *ngFor="let d of lrsLinkedDocuments"
              [class.active]="d.id === selectedLrsDocumentId"
            >
              <button type="button" class="geodoc-name" (click)="focusLrsDocument(d)">
                <strong>{{ d.document_name }}</strong>
                <small>#{{ d.id }}<ng-container *ngIf="lrsDocumentChainage(d)"> · {{ lrsDocumentChainage(d) }}</ng-container></small>
              </button>
              <span class="geodoc-actions">
                <button type="button" class="btn btn-ghost btn-sm" (click)="focusLrsDocument(d)">Map</button>
                <button type="button" class="btn btn-ghost btn-sm" (click)="downloadLrsDocument(d, $event)">Download</button>
              </span>
            </li>
          </ul>
          <p class="geodoc-hint" *ngIf="!lrsLinkedDocuments.length && selectedLrsRouteId">
            No documents linked to the selected route yet.
          </p>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🛣️ LRS Network</h3>
        <div class="lrs-loader">
          <div class="control-group">
            <label>Route (chainage network):</label>
            <select
              [value]="selectedLrsRouteId ?? ''"
              (change)="onLrsRouteSelect($any($event.target).value)">
              <option value="" disabled>— select route —</option>
              <option *ngFor="let r of lrsRoutes" [value]="r.id">
                {{ r.route_code }} · {{ r.route_name }} ({{ (r.length_m || 0) / 1000 | number: '1.1-1' }} km)
              </option>
            </select>
          </div>
          <label class="lrs-check">
            <input type="checkbox" [checked]="lrsIncludeUtilities" (change)="lrsIncludeUtilities = $any($event.target).checked" />
            Include utilities
          </label>
          <label class="lrs-check">
            <input type="checkbox" [checked]="lrsIncludeCarriageways" (change)="lrsIncludeCarriageways = $any($event.target).checked" />
            Carriageways & lanes
          </label>
          <label class="lrs-check">
            <input type="checkbox" [checked]="lrsIncludeChainage" (change)="lrsIncludeChainage = $any($event.target).checked" />
            LRS chainage markers
          </label>
          <label class="lrs-check">
            <input type="checkbox" [checked]="lrsIncludeRowBand" (change)="toggleLrsRowBand($any($event.target).checked)" />
            ROW corridor band
          </label>
          <div class="control-group" *ngIf="lrsIncludeChainage">
            <label>Interval:</label>
            <select [value]="chainageIntervalM" (change)="setChainageIntervalM(+$any($event.target).value)">
              <option *ngFor="let m of chainageIntervalOptions" [value]="m">{{ m }} m</option>
            </select>
          </div>
          <div class="btn-group" style="margin-top: 6px;">
            <button class="btn" (click)="loadLrsRouteToMap()" [disabled]="lrsLoading || !selectedLrsRouteId">
              {{ lrsLoading ? 'Loading…' : '⬇️ Load LRS data' }}
            </button>
            <button class="btn" (click)="loadLrsRouteList()" title="Refresh route list">🔄</button>
          </div>
          <div class="lrs-status" *ngIf="lrsStatus">{{ lrsStatus }}</div>
          <div class="lrs-hint">
            Loads centerline, assets, utilities into editable layers under the <b>LRS</b> group.
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🗂️ Data Sources</h3>
        <div class="data-sources">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="addWmsLayer">🌐 WMS Layer</button>
            <button class="btn" id="addWfsLayer">📡 WFS Layer</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="addVectorLayer">📊 Vector</button>
            <button class="btn" id="addRasterLayer">🖼️ Raster</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="addDatabaseLayer">🗃️ Database</button>
            <button class="btn" id="addApiLayer">🔌 API Layer</button>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Layer Name:</label>
            <input type="text" id="newLayerName" placeholder="Enter layer name" style="width: 100%; margin-top: 2px; font-size: 10px;">
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Layer Type:</label>
            <select id="newLayerType" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option value="point">Point</option>
              <option value="line">Line</option>
              <option value="polygon">Polygon</option>
              <option value="raster">Raster</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>📁 Import/Export</h3>
        <div class="import-export-tools">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="importShapefile">📐 Shapefile</button>
            <button class="btn" id="importGeoJSON">🗺️ GeoJSON</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="importKML">📍 KML/KMZ</button>
            <button class="btn" id="importGPX">🎯 GPX</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="importCAD">🏗️ CAD (DXF/DWG)</button>
            <button class="btn" id="importCSV">📊 CSV</button>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Export Format:</label>
            <select id="exportFormat" style="width: 100%; margin-top: 2px; font-size: 10px;">
              <option value="geojson">GeoJSON</option>
              <option value="shapefile">Shapefile</option>
              <option value="kml">KML</option>
              <option value="gpx">GPX</option>
              <option value="dxf">DXF</option>
              <option value="csv">CSV</option>
              <option value="pdf">PDF</option>
              <option value="png">PNG</option>
              <option value="jpeg">JPEG</option>
            </select>
          </div>
          <div class="control-group">
            <label style="color: white; font-size: 9px;">Include Attributes:</label>
            <input type="checkbox" id="includeAttributes" checked> Include attribute data
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🔍 Data Validation</h3>
        <div class="validation-tools">
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="validateGeometry"> Geometry</button>
            <button class="btn" id="validateTopology">🔗 Topology</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="checkDuplicates">🔄 Duplicates</button>
            <button class="btn" id="checkGaps">🕳️ Gaps</button>
          </div>
          <div class="btn-group" style="margin-bottom: 6px;">
            <button class="btn" id="repairGeometry">🔧 Repair</button>
            <button class="btn" id="cleanData">🧹 Clean</button>
          </div>
          <div class="validation-results" id="validationResults" style="display: none; background: #34495e; padding: 8px; border-radius: 4px; margin-top: 6px; font-size: 10px;">
            <div><strong>Validation Results:</strong></div>
            <div id="validationResultsContent">No validation performed</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Settings Tab -->
    <div class="tab-content" id="settings-tab">
      <div class="sidebar-section">
        <h3>⚙️ Map Editor Settings</h3>
        <div class="control-group">
          <label>Default Map Center:</label>
          <input type="text" id="defaultCenter" value="28.6139, 77.2090" placeholder="Lat, Lon">
        </div>
        <div class="control-group">
          <label>Default Zoom Level:</label>
          <input type="range" id="defaultZoom" min="1" max="18" value="10">
          <span id="zoomValue">10</span>
        </div>
        <div class="control-group">
          <label>Snap Tolerance (pixels):</label>
          <input type="range" id="snapTolerance" min="5" max="50" value="15">
          <span id="snapValue">15</span>
        </div>
        <div class="control-group">
          <label>Auto-save Interval (minutes):</label>
          <select id="autoSaveInterval">
            <option value="0">Disabled</option>
            <option value="5" selected>5 minutes</option>
            <option value="10">10 minutes</option>
            <option value="15">15 minutes</option>
          </select>
        </div>
        <div class="control-group">
          <label>Default Coordinate System:</label>
          <select id="defaultCRS">
            <option value="EPSG:4326" selected>WGS84 (EPSG:4326)</option>
            <option value="EPSG:3857">Web Mercator (EPSG:3857)</option>
            <option value="EPSG:32643">UTM Zone 43N</option>
            <option value="EPSG:32644">UTM Zone 44N</option>
          </select>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>💾 Default Parameters Storage</h3>
        <div class="btn-group">
          <button class="btn" id="saveDefaults">💾 Save Defaults</button>
          <button class="btn" id="loadDefaults">📁 Load Defaults</button>
          <button class="btn" id="resetDefaults">🔄 Reset</button>
        </div>
        <div class="project-info" style="margin-top: 8px;">
          <div>Last Saved: <span id="lastSaved">Never</span></div>
          <div>Settings Version: v3.0</div>
        </div>
      </div>

      <div class="sidebar-section">
        <h3>🎨 Display Preferences</h3>
        <div class="control-group">
          <label>Grid Display:</label>
          <input type="checkbox" id="showGrid"> Show coordinate grid
        </div>
        <div class="control-group">
          <label>Scale Bar:</label>
          <input type="checkbox" id="showScaleBar" checked> Show scale bar
        </div>
        <div class="control-group">
          <label>North Arrow:</label>
          <input type="checkbox" id="showNorthArrow" checked> Show north arrow
        </div>
        <div class="control-group">
          <label>Measurement Units:</label>
          <select
            id="measurementUnits"
            [ngModel]="measureDisplayUnit"
            (ngModelChange)="setMeasureDisplayUnit($event)"
          >
            <option value="m">Metres (m)</option>
            <option value="km">Kilometres (km)</option>
            <option value="mi">Miles (mi)</option>
          </select>
        </div>
        <div class="control-group">
          <label>High DPI Support:</label>
          <input type="checkbox" id="highDpiSupport" checked> Enable high DPI rendering
        </div>
        <div class="control-group">
          <label>Hardware Acceleration:</label>
          <input type="checkbox" id="hardwareAcceleration" checked> Enable hardware acceleration
        </div>
      </div>
    </div>

    <!-- Layer Context Menu -->
    <div 
      class="layer-context-menu" 
      *ngIf="layerContextMenu.visible"
      [style.left.px]="layerContextMenu.x"
      [style.top.px]="layerContextMenu.y"
      (click)="$event.stopPropagation()">
      <div class="context-menu-item" (click)="toggleLayerEnhanced(layerContextMenu.layerId!, !getLayerInfo(layerContextMenu.layerId!).visible); hideLayerContextMenu()">
        {{ getLayerInfo(layerContextMenu.layerId!).visible ? 'Hide' : 'Show' }} Layer
      </div>
      <div class="context-menu-item" (click)="zoomToLayer(layerContextMenu.layerId!); hideLayerContextMenu()">
        Zoom to Layer
      </div>
      <div class="context-menu-divider"></div>
      <div class="context-menu-item" (click)="editLayerProperties(layerContextMenu.layerId!); hideLayerContextMenu()">
        Properties...
      </div>
      <div class="context-menu-item" (click)="toggleLayerLock(layerContextMenu.layerId!); hideLayerContextMenu()">
        {{ isLayerLocked(layerContextMenu.layerId!) ? 'Unlock' : 'Lock' }} Layer
      </div>
      <div class="context-menu-divider"></div>
      <div class="context-menu-item" (click)="duplicateLayer(layerContextMenu.layerId!, layerContextMenu.layerId! + '_copy'); hideLayerContextMenu()">
        Duplicate
      </div>
      <div class="context-menu-item" (click)="clearLayer(layerContextMenu.layerId!); hideLayerContextMenu()">
        Clear Features
      </div>
      <div class="context-menu-divider"></div>
      <div class="context-menu-item" (click)="exportLayerToFile(layerContextMenu.layerId!); hideLayerContextMenu()">
        Export...
      </div>
      <div class="context-menu-item danger" (click)="deleteLayer(layerContextMenu.layerId!); hideLayerContextMenu()">
        Remove Layer
      </div>
    </div>

    </div>
    <button
      type="button"
      class="sidebar__toggle"
      (click)="toggleSidebar()"
      [attr.aria-expanded]="!sidebarCollapsed"
      [attr.aria-label]="(sidebarCollapsed ? 'Show ' : 'Hide ') + sidebarTabLabel + ' panel'"
      [attr.title]="(sidebarCollapsed ? 'Show ' : 'Hide ') + sidebarTabLabel + ' panel'"
    >
      <span class="sidebar__toggle-label">{{ sidebarTabLabel }}</span>
    </button>
  </div>
  <div class="sidebar-backdrop" (click)="collapseSidebarOverlay()" aria-hidden="true"></div>

  <div class="map-container">
    <div class="toolbar" #toolbarEl>
      <div class="toolbar-primary" #toolbarPrimary>
      <!-- Basemap & units (header) -->
      <div class="toolbar-group toolbar-group--persist" data-label="Basemap">
        <label class="toolbar-field" title="Base map">
          <span class="toolbar-field__label">Map</span>
          <select
            class="toolbar-select"
            [ngModel]="selectedBaseMapKey"
            (ngModelChange)="pickBaseMap($event)"
            aria-label="Base map"
          >
            <optgroup label="Street">
              <option value="google">Google Streets</option>
              <option value="osm">OpenStreetMap</option>
            </optgroup>
            <optgroup label="Satellite &amp; terrain">
              <option value="googleSatellite">Google Satellite</option>
              <option value="googleHybrid">Google Hybrid</option>
              <option value="googleTerrain">Google Terrain</option>
              <option value="satellite">ESRI Satellite</option>
              <option value="terrain">ESRI Topo</option>
            </optgroup>
            <optgroup label="Other">
              <option value="dark">Dark</option>
              <option value="custom">Custom XYZ…</option>
            </optgroup>
          </select>
        </label>
        <label class="toolbar-field" title="Measurement units">
          <span class="toolbar-field__label">Unit</span>
          <select
            class="toolbar-select toolbar-select--unit"
            [ngModel]="measureDisplayUnit"
            (ngModelChange)="setMeasureDisplayUnit($event)"
            aria-label="Length unit"
          >
            <option value="m">m</option>
            <option value="km">km</option>
            <option value="mi">mi</option>
          </select>
        </label>
      </div>

      <div class="toolbar-divider"></div>

      <!-- Zoom Controls -->
      <div class="toolbar-group" data-label="Zoom">
        <button
          type="button"
          class="toolbar-btn"
          [class.active]="locationSearchOpen"
          (click)="toggleLocationSearch()"
          title="Search places and directions (Ctrl+K)"
          aria-label="Search places and directions"
        >
          <span class="btn-icon">🔎</span>
          <span class="btn-text">Search</span>
        </button>
        <button class="toolbar-btn" id="zoomIn" title="Zoom In">
          <span class="btn-icon">🔍</span>
          <span class="btn-text">+</span>
        </button>
        <button class="toolbar-btn" id="zoomOut" title="Zoom Out">
          <span class="btn-icon">🔍</span>
          <span class="btn-text">-</span>
        </button>
        <button class="toolbar-btn" id="zoomFit" title="Fit to Extent">
          <span class="btn-icon">⌘</span>
          <span class="btn-text">Fit</span>
        </button>
        <button class="toolbar-btn" id="zoomExtent" title="Zoom to Extent">
          <span class="btn-icon">🎯</span>
        </button>
        <button class="toolbar-btn" id="zoomPrevious" title="Previous View">
          <span class="btn-icon">↶</span>
        </button>
        <button class="toolbar-btn" id="zoomNext" title="Next View">
          <span class="btn-icon">↷</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <!-- Navigation Tools -->
      <div class="toolbar-group" data-label="Navigate & Edit">
        <button class="toolbar-btn" id="panBtn" title="Pan">
          <span class="btn-icon">👋</span>
          <span class="btn-text">Pan</span>
        </button>
        <button class="toolbar-btn" id="selectBtn" title="Select">
          <span class="btn-icon">👆</span>
          <span class="btn-text">Select</span>
        </button>
        <button class="toolbar-btn" id="modifyBtn" title="Edit">
          <span class="btn-icon">✏️</span>
          <span class="btn-text">Edit</span>
        </button>
        <button class="toolbar-btn" id="moveBtn" title="Move">
          <span class="btn-icon">✋</span>
          <span class="btn-text">Move</span>
        </button>
        <button
          type="button"
          class="toolbar-btn"
          id="rotateBtn"
          title="Rotate: drag around the selection centre (Shift snaps 15°), [ ] rotate 15°, A for an exact angle"
        >
          <span class="btn-icon">⟳</span>
          <span class="btn-text">Rotate</span>
        </button>
        <button
          type="button"
          class="toolbar-btn"
          id="copyFeatureBtn"
          title="Copy selected features (Ctrl/Cmd+C). Ctrl/Cmd+D duplicates in place"
          (click)="copySelectedFeatures()"
        >
          <span class="btn-icon">📋</span>
          <span class="btn-text">Copy</span>
        </button>
        <button
          type="button"
          class="toolbar-btn"
          id="pasteFeatureBtn"
          title="Paste at the cursor (Ctrl/Cmd+V)"
          [disabled]="!hasClipboard"
          (click)="pasteFeatures()"
        >
          <span class="btn-icon">📥</span>
          <span class="btn-text">Paste</span>
        </button>
        <button class="toolbar-btn" id="deleteBtn" title="Delete">
          <span class="btn-icon">🗑️</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <!-- View & Settings -->
      <div class="toolbar-group" data-label="View">
        <button class="toolbar-btn" id="fullscreenBtn" title="Fullscreen">
          <span class="btn-icon">📺</span>
        </button>
        <button
          type="button"
          class="toolbar-btn"
          [class.active]="isGisFocusMode"
          (click)="isGisFocusMode ? exitGisFocusMode() : enterGisFocusMode()"
          [title]="isGisFocusMode ? 'Exit focus (Esc)' : 'Hide header and sidenav'"
        >
          <span class="btn-icon">⛶</span>
        </button>
        <button class="toolbar-btn" id="layersBtn" title="Layers">
          <span class="btn-icon">🗂️</span>
        </button>
        <button class="toolbar-btn" id="settingsBtn" title="Settings">
          <span class="btn-icon">⚙️</span>
        </button>
        <button class="toolbar-btn" id="helpBtn" title="Help">
          <span class="btn-icon">❓</span>
        </button>
      </div>
      </div>

      <button
        type="button"
        class="toolbar-more-btn"
        (click)="toggleToolbarMore($event)"
        [class.active]="toolbarMoreOpen"
        title="More tools"
        aria-label="More tools"
        [attr.aria-expanded]="toolbarMoreOpen"
      >
        More
      </button>

      <div class="toolbar-secondary" [class.toolbar-secondary--open]="toolbarMoreOpen">
      <div class="toolbar-overflow-slot" #toolbarOverflowSlot></div>
      <!-- Measurement Tools -->
      <div class="toolbar-group" data-label="Measure">
        <button class="toolbar-btn" id="measureBtn" title="Measure Distance">
          <span class="btn-icon">📏</span>
          <span class="btn-text">Dist</span>
        </button>
        <button class="toolbar-btn" id="areaBtn" title="Measure Area">
          <span class="btn-icon">📐</span>
          <span class="btn-text">Area</span>
        </button>
        <button class="toolbar-btn" id="bearingBtn" title="Bearing">
          <span class="btn-icon">🧭</span>
        </button>
        <button class="toolbar-btn" id="angleBtn" title="Angle">
          <span class="btn-icon">📐</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <div class="toolbar-group" data-label="Corridor">
        <button class="toolbar-btn" id="splitBtn" title="Split Segment">
          <span class="btn-icon">✂️</span>
          <span class="btn-text">Split</span>
        </button>
        <button class="toolbar-btn" id="profileBtn" title="Elevation Profile">
          <span class="btn-icon">📈</span>
          <span class="btn-text">Profile</span>
        </button>
        <button
          type="button"
          class="toolbar-btn"
          id="parallelLineBtn"
          title="Create parallel line(s) from selection"
          (click)="createParallelLines()"
        >
          <span class="btn-icon">⫸</span>
          <span class="btn-text">Parallel</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <!-- History & Selection -->
      <div class="toolbar-group" data-label="History">
        <button class="toolbar-btn" id="undoBtn" title="Undo">
          <span class="btn-icon">↶</span>
        </button>
        <button class="toolbar-btn" id="redoBtn" title="Redo">
          <span class="btn-icon">↷</span>
        </button>
        <button class="toolbar-btn" id="clearBtn" title="Clear">
          <span class="btn-icon">🗑️</span>
        </button>
        <button class="toolbar-btn" id="selectAllBtn" title="Select All">
          <span class="btn-icon">☑️</span>
        </button>
        <button class="toolbar-btn" id="clearSelectionBtn" title="Clear Selection">
          <span class="btn-icon">☐</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <!-- File Operations -->
      <div class="toolbar-group" data-label="File">
        <button class="toolbar-btn" id="saveBtn" title="Save" [disabled]="isSavingAllLayers">
          <span class="btn-icon">💾</span>
          <span class="btn-text">{{ isSavingAllLayers ? 'Saving…' : 'Save' }}</span>
        </button>
        <button class="toolbar-btn" id="loadBtn" title="Load">
          <span class="btn-icon">📂</span>
          <span class="btn-text">Load</span>
        </button>
        <button class="toolbar-btn" id="exportBtn" title="Export">
          <span class="btn-icon">💾</span>
        </button>
        <button class="toolbar-btn" id="importBtn" title="Import">
          <span class="btn-icon">📁</span>
        </button>
        <button class="toolbar-btn" id="printBtn" title="Print">
          <span class="btn-icon">🖨️</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <!-- Display Options -->
      <div class="toolbar-group" data-label="Display">
        <button class="toolbar-btn" id="snapBtn" title="Snap to Grid">
          <span class="btn-icon">🧲</span>
        </button>
        <button class="toolbar-btn" id="gridBtn" title="Show Grid">
          <span class="btn-icon">⊞</span>
        </button>
        <button class="toolbar-btn" id="coordsBtn" title="Show Coordinates">
          <span class="btn-icon">📍</span>
        </button>
        <button class="toolbar-btn" id="scaleBtn" title="Show Scale">
          <span class="btn-icon">📏</span>
        </button>
        <button class="toolbar-btn" id="northBtn" title="Reset North">
          <span class="btn-icon">🧭</span>
        </button>
      </div>
      </div>
    </div>

    <div id="map" #mapEl></div>

    <app-gis-location-search
      *ngIf="map && locationSearchOpen"
      [map]="map"
      [lrsRoutes]="lrsRoutes"
      [selectedLrsRouteId]="selectedLrsRouteId"
      [searchFeatures]="searchProjectFeatures"
      [topOffset]="locationSearchTop"
      (closed)="locationSearchOpen = false"
    ></app-gis-location-search>

    <app-gis-asset-bridge-panel [vectorSource]="vectorSource" [lrsRouteId]="selectedLrsRouteId"></app-gis-asset-bridge-panel>

    <!-- Editable road feature panel (Select tool → click road) -->
    <aside class="road-edit-card" *ngIf="roadEditDetail">
      <header class="road-edit-card-header">
        <div class="road-edit-card-title">
          <h4>Edit Road</h4>
          <small>{{ roadEditDetail.name }} <span class="road-edit-badge">editable</span></small>
        </div>
        <button type="button" class="road-edit-card-close" (click)="closeRoadEditDetail()" aria-label="Close">×</button>
      </header>
      <form class="road-edit-card-body" (submit)="$event.preventDefault(); saveRoadEditDetail()">
        <label class="road-edit-field road-edit-field--full">
          <span>Name</span>
          <input type="text" [(ngModel)]="roadEditDetail.name" name="roadName" />
        </label>
        <label class="road-edit-field">
          <span>Type</span>
          <select [(ngModel)]="roadEditDetail.roadType" name="roadType">
            <option *ngFor="let opt of roadTypeOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </label>
        <label class="road-edit-field">
          <span>Lanes</span>
          <select [(ngModel)]="roadEditDetail.lanes" name="roadLanes">
            <option *ngFor="let n of roadLaneOptions" [ngValue]="n">{{ n }}</option>
          </select>
        </label>
        <label class="road-edit-field">
          <span>Width (m)</span>
          <input type="number" min="3" max="80" step="0.5" [(ngModel)]="roadEditDetail.widthM" name="roadWidth" />
        </label>
        <label class="road-edit-field">
          <span>Depth (m)</span>
          <input type="number" min="0.1" max="10" step="0.1" [(ngModel)]="roadEditDetail.depthM" name="roadDepth" />
        </label>
        <label class="road-edit-field">
          <span>Surface</span>
          <select [(ngModel)]="roadEditDetail.surface" name="roadSurface">
            <option *ngFor="let opt of roadSurfaceOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </label>
        <label class="road-edit-field">
          <span>Divider</span>
          <select [(ngModel)]="roadEditDetail.dividerType" name="roadDivider" (ngModelChange)="onRoadDividerTypeChange()">
            <option *ngFor="let opt of roadDividerOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </label>
        <label class="road-edit-field" *ngIf="roadEditDetail.dividerType !== 'none'">
          <span>Divider W (m)</span>
          <input type="number" min="0" max="5" step="0.1" [(ngModel)]="roadEditDetail.dividerWidthM" name="dividerWidth" />
        </label>
        <label class="road-edit-field">
          <span>Sep. dist. (m)</span>
          <input type="number" min="0.5" max="20" step="0.5" [(ngModel)]="roadEditDetail.separatorDistanceM" name="sepDist" />
        </label>
        <label class="road-edit-field road-edit-field--full">
          <span>Comment</span>
          <textarea rows="2" [(ngModel)]="roadEditDetail.comment" name="roadComment"></textarea>
        </label>
        <div class="road-edit-card-actions">
          <button type="submit" class="btn road-edit-save-btn">Save</button>
          <button type="button" class="btn btn-secondary-inline" (click)="closeRoadEditDetail()">Cancel</button>
        </div>
      </form>
    </aside>

    <!-- LRS asset details (full pane, same as LRS Manager) -->
    <aside class="lrs-asset-card lrs-asset-card--full" *ngIf="lrsDetailId && lrsDetailKind">
      <app-lrs-asset-details
        [kind]="lrsDetailKind"
        [assetId]="lrsDetailId"
        (closed)="closeLrsAssetDetail()"
        (saved)="onGisLrsAssetSaved()"
        (retired)="onGisLrsAssetRetired()"
        (openLinked)="openGisLinkedAsset($event)"
      ></app-lrs-asset-details>
    </aside>

    <div class="lrs-chainage-hud" *ngIf="selectedLrsRouteId">
      <strong *ngIf="chainageHudLabel">{{ chainageHudLabel }}</strong>
      <span *ngIf="chainageHudLabel && mapScaleLabel"> · </span>
      <span *ngIf="mapScaleLabel">1:{{ mapScaleLabel }}</span>
      <span *ngIf="mapZoom != null"> · z{{ mapZoom }}</span>
    </div>

    <div class="coordinates" id="coordinates" *ngIf="!selectedLrsRouteId" [style.visibility]="locationSearchOpen ? 'hidden' : null">
      Lat: 28.613900, Lon: 77.209000 | Scale: 1:50000 | Zoom: 10
    </div>
    <a class="osm-map-attribution" *ngIf="osmNetworkEnabled && osmRoadCount > 0"
       href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">
      © OpenStreetMap contributors
    </a>

    <!-- Enhanced Status Bar -->
    <div class="status-bar" id="statusBar" [class.lrs-status-slim]="activeSidebarTab === 'lrs'">
      <div class="status-left">
        <span id="projectStatus">Ready</span>
        <span id="layerCount">Layers: 0</span>
        <span id="featureCount">Features: 0</span>
        <span id="selectedCount" *ngIf="activeSidebarTab !== 'lrs'">Selected: 0</span>
        <span
          id="osmStatus"
          class="osm-status"
          *ngIf="osmNetworkEnabled && osmNetworkStatus"
          [class.osm-status--error]="osmStatusIsError"
          [title]="osmNetworkStatus"
        >{{ osmNetworkStatus }}</span>
      </div>
      <div class="status-right" *ngIf="activeSidebarTab !== 'lrs'">
        <span id="memoryUsage">Memory: 0MB</span>
        <span id="cpuUsage">CPU: 0%</span>
        <span id="lastSaved">Last saved: Never</span>
        <span id="connectionStatus">🟢 Online</span>
      </div>
    </div>

    <div class="parameter-display" id="parameterDisplay">
      <div><strong>📊 Project Parameters</strong></div>
      <div>Project: NH-44 Delhi-Mumbai</div>
      <div>Chainage: KM 45+250</div>
      <div>Segment: S-12, Sub: A</div>
      <div>Width: 45m (8 lanes)</div>
      <div>Grade: +2.5%</div>
      <div>Surface: Bituminous</div>
    </div>

    <div class="measurement-display" id="measurementDisplay">
      <div><strong>📐 Measurements</strong></div>
      <div id="measurementResults">
        Click on features to measure
      </div>
    </div>

    <div class="mini-toolbar" id="miniToolbar">
      <div>🎯 Multi-line Mode Active</div>
      <div>Lines: <span id="activeLineCount">3</span></div>
      <div>Current: Line <span id="currentLineId">2</span></div>
    </div>

    <div class="settings-panel" id="settingsPanel">
      <h4>⚙️ Map Editor Settings</h4>
      <div class="control-group">
        <label>Snap to Grid:</label>
        <input type="checkbox" id="snapToGrid" checked>
      </div>
      <div class="control-group">
        <label>Show Coordinates:</label>
        <input type="checkbox" id="showCoords" checked>
      </div>
      <div class="control-group">
        <label>Auto-save:</label>
        <input type="checkbox" id="autoSave" checked>
      </div>
      <div class="control-group">
        <label>Default Line Color:</label>
        <input type="color" id="defaultLineColor" value="#3498db">
      </div>
      <div class="control-group">
        <label>Background Color:</label>
        <input type="color" id="backgroundColor" value="#f0f2f5">
      </div>
      <div class="btn-group">
        <button class="btn" id="applySettings"> Apply</button>
        <button class="btn" id="closeSettings">❌ Close</button>
      </div>
    </div>

    <div class="feature-info" id="featureInfo">
      <h4>Feature Information</h4>
      <div id="featureDetails"></div>
      <button class="btn" id="saveFeatureProps">Save</button>
    </div>

    <div class="feature-properties-dialog" id="featurePropertiesDialog">
      <h4>🏗️ Feature Properties</h4>
      <div class="properties-form">
        <div class="control-group">
          <label>Feature Name:</label>
          <input type="text" id="featureName" placeholder="Enter feature name">
        </div>
        <div class="control-group">
          <label>Width (m):</label>
          <input type="number" id="featureWidth" min="0.1" max="100" step="0.1" value="12">
        </div>
        <div class="control-group">
          <label>Depth (m):</label>
          <input type="number" id="featureDepth" min="0.1" max="10" step="0.1" value="0.5">
        </div>
        <div class="control-group">
          <label>Lanes:</label>
          <select id="featureLanes">
            <option value="1">1 Lane</option>
            <option value="2" selected>2 Lanes</option>
            <option value="3">3 Lanes</option>
            <option value="4">4 Lanes</option>
            <option value="6">6 Lanes</option>
            <option value="8">8 Lanes</option>
          </select>
        </div>
        <div class="control-group">
          <label>Material:</label>
          <select id="featureMaterial">
            <option value="bituminous">Bituminous</option>
            <option value="concrete">Concrete</option>
            <option value="gravel">Gravel</option>
            <option value="earthen">Earthen</option>
          </select>
        </div>
        <div class="control-group">
          <label>Status:</label>
          <select id="featureStatus">
            <option value="planned">Planned</option>
            <option value="under_construction">Under Construction</option>
            <option value="completed">Completed</option>
            <option value="maintenance">Maintenance</option>
          </select>
        </div>
        <div class="control-group">
          <label>Comments:</label>
          <textarea id="featureComments" rows="3" placeholder="Additional comments..."></textarea>
        </div>
      </div>
      <div class="btn-group">
        <button class="btn" id="saveFeatureProperties">💾 Save Properties</button>
        <button class="btn" id="cancelFeatureProperties">❌ Cancel</button>
      </div>
    </div>

    <div id="popup" class="popup"></div>

    <!-- Enhanced Enterprise Dialogs -->
    <div class="enterprise-dialogs">
      <!-- WMS Layer Dialog -->
      <div class="dialog-overlay" id="wmsDialog" style="display: none;">
        <div class="dialog">
          <div class="dialog-header">
            <h3>🌐 Add WMS Layer</h3>
            <button class="close-btn" (click)="closeDialog('wmsDialog')">×</button>
          </div>
          <div class="dialog-content">
            <div class="form-group">
              <label>WMS Service URL:</label>
              <input type="url" id="wmsUrl" placeholder="https://example.com/wms">
            </div>
            <div class="form-group">
              <label>Layer Name:</label>
              <input type="text" id="wmsLayerName" placeholder="Enter layer name">
            </div>
            <div class="form-group">
              <label>Format:</label>
              <select id="wmsFormat">
                <option value="image/png">PNG</option>
                <option value="image/jpeg">JPEG</option>
                <option value="image/gif">GIF</option>
              </select>
            </div>
            <div class="form-group">
              <label>Transparency:</label>
              <input type="range" id="wmsTransparency" min="0" max="100" value="0">
              <span id="wmsTransparencyValue">0%</span>
            </div>
          </div>
          <div class="dialog-footer">
            <button class="btn" (click)="closeDialog('wmsDialog')">Cancel</button>
            <button class="btn primary" id="submitWmsLayerBtn" type="button">Add Layer</button>
          </div>
        </div>
      </div>

      <!-- Data Import Dialog -->
      <div class="dialog-overlay" id="importDialog" style="display: none;">
        <div class="dialog">
          <div class="dialog-header">
            <h3>📁 Import Data</h3>
            <button class="close-btn" (click)="closeDialog('importDialog')">×</button>
          </div>
          <div class="dialog-content">
            <div class="import-options">
              <div class="import-option" (click)="selectImportType('file')">
                <input type="radio" name="importType" value="file" checked>
                <label>📄 File Upload</label>
              </div>
              <div class="import-option" (click)="selectImportType('url')">
                <input type="radio" name="importType" value="url">
                <label>🌐 URL/Service</label>
              </div>
              <div class="import-option" (click)="selectImportType('database')">
                <input type="radio" name="importType" value="database">
                <label>🗃️ Database</label>
              </div>
            </div>
            <div class="import-content" id="importContent">
              <div class="form-group">
                <label>Select File:</label>
                <input type="file" id="importFile" accept=".shp,.geojson,.kml,.gpx,.csv,.dxf">
              </div>
              <div class="form-group">
                <label>Layer Name:</label>
                <input type="text" id="importLayerName" placeholder="Enter layer name">
              </div>
              <div class="form-group">
                <label>Coordinate System:</label>
                <select id="importCRS">
                  <option value="EPSG:4326">WGS84 (EPSG:4326)</option>
                  <option value="EPSG:3857">Web Mercator (EPSG:3857)</option>
                  <option value="EPSG:32643">UTM Zone 43N</option>
                </select>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <button class="btn" (click)="closeDialog('importDialog')">Cancel</button>
            <button class="btn primary" id="importDataBtn">Import</button>
          </div>
        </div>
      </div>

      <!-- Analysis Results Dialog -->
      <div class="dialog-overlay" id="analysisDialog" style="display: none;">
        <div class="dialog large">
          <div class="dialog-header">
            <h3>📊 Analysis Results</h3>
            <button class="close-btn" (click)="closeDialog('analysisDialog')">×</button>
          </div>
          <div class="dialog-content">
            <div class="analysis-tabs">
              <button class="tab-btn active" (click)="showAnalysisTab('summary')">Summary</button>
              <button class="tab-btn" (click)="showAnalysisTab('details')">Details</button>
              <button class="tab-btn" (click)="showAnalysisTab('charts')">Charts</button>
              <button class="tab-btn" (click)="showAnalysisTab('export')">Export</button>
            </div>
            <div class="analysis-content">
              <div id="analysisSummary" class="analysis-tab-content active">
                <div class="summary-stats">
                  <div class="stat-item">
                    <span class="stat-label">Total Features:</span>
                    <span class="stat-value" id="totalFeatures">0</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Total Area:</span>
                    <span class="stat-value" id="totalArea">0 m²</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Total Length:</span>
                    <span class="stat-value" id="totalLength">0 m</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Average Density:</span>
                    <span class="stat-value" id="avgDensity">0/km²</span>
                  </div>
                </div>
              </div>
              <div id="analysisDetails" class="analysis-tab-content">
                <div class="details-table">
                  <table id="analysisTable">
                    <thead>
                      <tr>
                        <th>Feature ID</th>
                        <th>Type</th>
                        <th>Area</th>
                        <th>Length</th>
                        <th>Attributes</th>
                      </tr>
                    </thead>
                    <tbody id="analysisTableBody">
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="analysisCharts" class="analysis-tab-content">
                <div class="chart-container">
                  <canvas id="analysisChart" width="400" height="300"></canvas>
                </div>
              </div>
              <div id="analysisExport" class="analysis-tab-content">
                <div class="export-options">
                  <div class="form-group">
                    <label>Export Format:</label>
                    <select id="analysisExportFormat">
                      <option value="pdf">PDF Report</option>
                      <option value="excel">Excel Spreadsheet</option>
                      <option value="csv">CSV Data</option>
                      <option value="json">JSON</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Include Charts:</label>
                    <input type="checkbox" id="includeCharts" checked>
                  </div>
                  <div class="form-group">
                    <label>Include Metadata:</label>
                    <input type="checkbox" id="includeMetadata" checked>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <button class="btn" (click)="closeDialog('analysisDialog')">Close</button>
            <button class="btn primary" id="exportAnalysisBtn">Export Results</button>
          </div>
        </div>
      </div>

      <!-- Layer Properties Dialog -->
      <div class="dialog-overlay" id="layerPropertiesDialog" style="display: none;">
        <div class="dialog">
          <div class="dialog-header">
            <h3>🗂️ Layer Properties</h3>
            <button class="close-btn" (click)="closeDialog('layerPropertiesDialog')">×</button>
          </div>
          <div class="dialog-content">
            <div class="properties-tabs">
              <button class="tab-btn active" (click)="showPropertiesTab('general')">General</button>
              <button class="tab-btn" (click)="showPropertiesTab('style')">Style</button>
              <button class="tab-btn" (click)="showPropertiesTab('data')">Data</button>
              <button class="tab-btn" (click)="showPropertiesTab('filters')">Filters</button>
            </div>
            <div class="properties-content">
              <div id="propertiesGeneral" class="properties-tab-content active">
                <div class="form-group">
                  <label>Layer Name:</label>
                  <input type="text" id="layerName" placeholder="Enter layer name">
                </div>
                <div class="form-group">
                  <label>Description:</label>
                  <textarea id="layerDescription" rows="3" placeholder="Enter layer description"></textarea>
                </div>
                <div class="form-group">
                  <label>Coordinate System:</label>
                  <select id="layerCRS">
                    <option value="EPSG:4326">WGS84 (EPSG:4326)</option>
                    <option value="EPSG:3857">Web Mercator (EPSG:3857)</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Visibility:</label>
                  <input type="checkbox" id="layerVisible" checked> Visible
                </div>
              </div>
              <div id="propertiesStyle" class="properties-tab-content">
                <div class="form-group">
                  <label>Fill Color:</label>
                  <input type="color" id="fillColor" value="#3498db">
                </div>
                <div class="form-group">
                  <label>Stroke Color:</label>
                  <input type="color" id="strokeColor" value="#2980b9">
                </div>
                <div class="form-group">
                  <label>Stroke Width:</label>
                  <input type="range" id="strokeWidth" min="1" max="10" value="2">
                  <span id="strokeWidthValue">2px</span>
                </div>
                <div class="form-group">
                  <label>Opacity:</label>
                  <input type="range" id="layerOpacity" min="0" max="100" value="100">
                  <span id="layerOpacityValue">100%</span>
                </div>
              </div>
              <div id="propertiesData" class="properties-tab-content">
                <div class="data-table">
                  <table id="layerDataTable">
                    <thead>
                      <tr>
                        <th>Attribute</th>
                        <th>Type</th>
                        <th>Values</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody id="layerDataTableBody">
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="propertiesFilters" class="properties-tab-content">
                <div class="form-group">
                  <label>Filter Expression:</label>
                  <textarea id="filterExpression" rows="3" placeholder="Enter filter expression"></textarea>
                </div>
                <div class="form-group">
                  <label>Filter Type:</label>
                  <select id="filterType">
                    <option value="attribute">Attribute Filter</option>
                    <option value="spatial">Spatial Filter</option>
                    <option value="temporal">Temporal Filter</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <button class="btn" (click)="closeDialog('layerPropertiesDialog')">Cancel</button>
            <button class="btn primary" id="saveLayerPropertiesBtn">Save</button>
          </div>
        </div>
      </div>

      <!-- Print Layout Dialog -->
      <div class="dialog-overlay" id="printDialog" style="display: none;">
        <div class="dialog">
          <div class="dialog-header">
            <h3>🖨️ Print Layout</h3>
            <button class="close-btn" (click)="closeDialog('printDialog')">×</button>
          </div>
          <div class="dialog-content">
            <div class="form-group">
              <label>Paper Size:</label>
              <select id="paperSize">
                <option value="A4">A4</option>
                <option value="A3">A3</option>
                <option value="A2">A2</option>
                <option value="A1">A1</option>
                <option value="A0">A0</option>
                <option value="Letter">Letter</option>
                <option value="Legal">Legal</option>
              </select>
            </div>
            <div class="form-group">
              <label>Orientation:</label>
              <select id="paperOrientation">
                <option value="portrait">Portrait</option>
                <option value="landscape">Landscape</option>
              </select>
            </div>
            <div class="form-group">
              <label>Scale:</label>
              <input type="text" id="printScale" placeholder="1:10000">
            </div>
            <div class="form-group">
              <label>Include Elements:</label>
              <div class="checkbox-group">
                <input type="checkbox" id="includeTitle" checked> <label>Title</label>
                <input type="checkbox" id="includeLegend" checked> <label>Legend</label>
                <input type="checkbox" id="includeScale" checked> <label>Scale Bar</label>
                <input type="checkbox" id="includeNorth" checked> <label>North Arrow</label>
                <input type="checkbox" id="includeCoords" checked> <label>Coordinates</label>
              </div>
            </div>
            <div class="form-group">
              <label>Title:</label>
              <input type="text" id="printTitle" placeholder="Enter map title">
            </div>
            <div class="form-group">
              <label>Margins (mm):</label>
              <div class="margin-inputs">
                <input type="number" id="marginTop" placeholder="Top" value="20">
                <input type="number" id="marginBottom" placeholder="Bottom" value="20">
                <input type="number" id="marginLeft" placeholder="Left" value="20">
                <input type="number" id="marginRight" placeholder="Right" value="20">
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <button class="btn" (click)="closeDialog('printDialog')">Cancel</button>
            <button class="btn primary" id="printMapBtn">Print</button>
            <button class="btn secondary" id="previewPrintBtn">Preview</button>
          </div>
        </div>
      </div>

      <!-- Advanced Search Dialog -->
      <div class="dialog-overlay" id="searchDialog" style="display: none;">
        <div class="dialog">
          <div class="dialog-header">
            <h3>🔍 Advanced Search</h3>
            <button class="close-btn" (click)="closeDialog('searchDialog')">×</button>
          </div>
          <div class="dialog-content">
            <div class="search-tabs">
              <button class="tab-btn active" (click)="showSearchTab('attribute')">Attribute</button>
              <button class="tab-btn" (click)="showSearchTab('spatial')">Spatial</button>
              <button class="tab-btn" (click)="showSearchTab('temporal')">Temporal</button>
            </div>
            <div class="search-content">
              <div id="searchAttribute" class="search-tab-content active">
                <div class="form-group">
                  <label>Search In:</label>
                  <select id="searchLayer">
                    <option value="all">All Layers</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Attribute:</label>
                  <select id="searchAttribute">
                    <option value="name">Name</option>
                    <option value="type">Type</option>
                    <option value="id">ID</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Operator:</label>
                  <select id="searchOperator">
                    <option value="equals">Equals</option>
                    <option value="contains">Contains</option>
                    <option value="starts_with">Starts With</option>
                    <option value="ends_with">Ends With</option>
                    <option value="greater_than">Greater Than</option>
                    <option value="less_than">Less Than</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Value:</label>
                  <input type="text" id="searchValue" placeholder="Enter search value">
                </div>
              </div>
              <div id="searchSpatial" class="search-tab-content">
                <div class="form-group">
                  <label>Spatial Relationship:</label>
                  <select id="spatialRelation">
                    <option value="intersects">Intersects</option>
                    <option value="contains">Contains</option>
                    <option value="within">Within</option>
                    <option value="touches">Touches</option>
                    <option value="crosses">Crosses</option>
                    <option value="overlaps">Overlaps</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Reference Geometry:</label>
                  <select id="referenceGeometry">
                    <option value="drawn">Drawn on Map</option>
                    <option value="selected">Selected Features</option>
                    <option value="layer">Layer Features</option>
                  </select>
                </div>
              </div>
              <div id="searchTemporal" class="search-tab-content">
                <div class="form-group">
                  <label>Date Field:</label>
                  <select id="dateField">
                    <option value="created_date">Created Date</option>
                    <option value="modified_date">Modified Date</option>
                    <option value="start_date">Start Date</option>
                    <option value="end_date">End Date</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Date Range:</label>
                  <div class="date-inputs">
                    <input type="date" id="startDate">
                    <input type="date" id="endDate">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <button class="btn" (click)="closeDialog('searchDialog')">Cancel</button>
            <button class="btn primary" id="executeSearchBtn">Search</button>
            <button class="btn secondary" id="clearSearchBtn">Clear</button>
          </div>
        </div>
      </div>
    </div>
  </div>
